export default {
  // layouts
  'pages.layouts.userLayout.title':
    'Leading Global Headhunter Management Platform',
  // app
  'pages.app.name': 'Luole Headhunter Assistant',

  // navigation
  'pages.navigation': 'Hunter Assistant',

  // menu
  'pages.menu.title': 'Hunter Assistant',
  'pages.menu.collapse': 'Collapse',
  'pages.menu.expand': 'Expand',
  'pages.menu.dashboard': 'Dashboard',
  'pages.menu.jobs': 'Jobs',
  'pages.menu.jobs.all': 'All Jobs',
  'pages.menu.jobs.my': 'My Jobs',
  'pages.menu.talents': 'Talents',
  'pages.menu.talents.all': 'All Talents',
  'pages.menu.talents.my': 'My Talents',
  'pages.menu.talents.private': 'My Private Pool',
  'pages.menu.talents.public': 'Public Pool',
  'pages.menu.talents.collections': 'Collections',
  'pages.menu.clients': 'Clients',
  'pages.menu.clients.all': 'All Clients',
  'pages.menu.clients.my': 'My Clients',
  'pages.menu.clients.myClients': 'My Clients',
  'pages.menu.clients.private': 'My Private Clients',
  'pages.menu.clients.privateClients': 'My Private Clients',
  'pages.menu.clients.public': 'Public Pool',
  'pages.menu.clients.publicClients': 'Public Pool',
  'pages.menu.clients.collections': 'Collections',
  'pages.menu.clients.clientCollection': 'Collections',
  'pages.menu.projects.collections': 'Collections',
  'pages.menu.projects': 'Projects',
  'pages.menu.projects.all': 'All Projects',
  'pages.menu.projects.my': 'My Projects',
  'pages.menu.projects.recommended': 'Recommended Projects',
  'pages.menu.projects.responsible': 'Responsible Projects',
  'pages.menu.projects.interviews': 'Interviews',
  'pages.menu.projects.interviews.phone': 'Phone Interviews',
  'pages.menu.projects.interviews.video': 'Video Interviews',
  'pages.menu.projects.interviews.face.to.face': 'Face-to-Face Interviews',
  'pages.menu.interviews': 'Interviews',
  'pages.menu.interviews.phone': 'Phone Interviews',
  'pages.menu.interviews.video': 'Video Interviews',
  'pages.menu.interviews.face.to.face': 'Face-to-Face Interviews',

  // interviews
  'pages.interviews.column.talent.name': 'Candidate Name',
  'pages.interviews.column.round': 'Round',
  'pages.interviews.column.type': 'Type',
  'pages.interviews.column.scheduled.date': 'Scheduled Date',
  'pages.interviews.column.location': 'Location',
  'pages.interviews.column.status': 'Status',

  'pages.menu.questions': 'Knowledge Center',
  'pages.menu.questions.all': 'All Questions',
  'pages.menu.questions.my': 'My Questions',
  'pages.menu.questions.my.answers': 'My Answers',
  'pages.menu.questions.categories': 'Categories',
  'pages.menu.analytics': 'Analytics',
  'pages.menu.analytics.overview': 'Overview',
  'pages.menu.analytics.jobs': 'Job Analytics',
  'pages.menu.analytics.talents': 'Talent Analytics',
  'pages.menu.analytics.clients': 'Client Analytics',
  'pages.menu.analytics.projects': 'Project Analytics',
  'pages.menu.analytics.work': 'Work Analytics',
  'pages.menu.daily.reports': 'Daily Reports',
  'pages.menu.daily.reports.today': 'Today',
  'pages.menu.daily.reports.all': 'All',
  'pages.menu.weekly.reports': 'Weekly Reports',
  'pages.menu.weekly.reports.this.week': 'This Week',
  'pages.menu.weekly.reports.all': 'All',
  'pages.menu.monthly.reports': 'Monthly Reports',
  'pages.menu.monthly.reports.this.month': 'This Month',
  'pages.menu.monthly.reports.all': 'All',
  'pages.menu.yearly.reports': 'Yearly Reports',
  'pages.menu.yearly.reports.this.year': 'This Year',
  'pages.menu.yearly.reports.all': 'All',
  'pages.menu.personal.settings': 'Personal Settings',
  'pages.menu.personal.settings.main': 'Profile',
  'pages.menu.personal.settings.messages': 'Message Center',
  'pages.menu.personal.settings.report.templates': 'Report Templates',
  'pages.menu.data.dictionaries': 'Data Dictionaries',
  'pages.menu.dataDictionaries': 'Data Dictionaries',

  // common
  'pages.common.of': 'of',
  'pages.common.loading': 'Loading...',
  'pages.common.all': 'All',
  'pages.common.view.details': 'View details',
  'pages.common.back': 'Back',
  'pages.common.edit': 'Edit',
  'pages.common.view': 'View',
  'pages.common.actions': 'Actions',
  'pages.common.total': 'Total',
  'pages.common.export': 'Export',
  'pages.common.comments': 'Comments',
  'pages.common.remarks': 'Remarks',
  'pages.common.messages': 'Messages',
  'pages.common.search': 'Search',
  'pages.common.search.placeholder': 'Multiple keywords separated by spaces',
  'pages.common.clear': 'Clear',
  'pages.common.default': 'Default',
  'pages.common.results': ' results',
  'pages.common.status.active': 'Active',
  'pages.common.status.inactive': 'Inactive',
  'pages.common.status.contacted': 'Contacted',
  'pages.common.status.interviewed': 'Interviewed',
  'pages.common.failed': ' failed',
  'pages.common.confirm': 'Confirm',
  'pages.common.cancel': 'Cancel',
  'pages.common.items': 'items',
  'pages.common.components.priority.high': 'High',
  'pages.common.components.priority.medium': 'Medium',
  'pages.common.components.priority.low': 'Low',
  'pages.common.components.salary.current.label': 'Current',
  'pages.common.components.salary.expected.label': 'Expected',
  'pages.common.components.experience.years': '{years} yrs experience',
  'pages.common.unknown': 'Unknown',
  'pages.common.not.provided': 'Not provided',
  'pages.common.minutes': 'mins',
  'pages.common.notes': 'Notes',
  'pages.common.notes.placeholder': 'Enter notes',
  'pages.common.copy': 'Copy',
  'pages.common.save': 'Save',
  'pages.common.send': 'Send',

  // operation
  'pages.operation.logs.title': 'Operation Logs',
  'pages.operation.logs.load.failed': 'Failed to load operation logs',
  'pages.operation.logs.filter.type.placeholder': 'Operation type',
  'pages.operation.logs.search.placeholder': 'Search description or operator',
  'pages.operation.logs.empty': 'No operation logs yet',
  'pages.operation.logs.operator.system': 'System',
  'pages.operation.logs.total': 'Total {total} records',
  'pages.operation.logs.type.create': 'Create',
  'pages.operation.logs.type.update': 'Update',
  'pages.operation.logs.type.delete': 'Delete',
  'pages.operation.logs.type.status.change': 'Status Change',
  'pages.operation.logs.type.associate': 'Associate',
  'pages.operation.logs.type.disassociate': 'Disassociate',
  'pages.operation.logs.value.empty': 'Empty',
  'pages.operation.logs.value.boolean.true': 'Yes',
  'pages.operation.logs.value.boolean.false': 'No',

  // dashboard
  'pages.dashboard': 'Dashboard',
  'pages.dashboard.title': 'Hunter Workspace Overview',
  'pages.dashboard.subtitle':
    'Track hiring progress, client pipelines, and project health in one place.',
  'pages.dashboard.total.talents': 'Total Talents',
  'pages.dashboard.active.jobs': 'Active Jobs',
  'pages.dashboard.total.clients': 'Total Clients',
  'pages.dashboard.active.projects': 'Active Projects',
  'pages.dashboard.success.rate.trend': 'Placement Success Trend',
  'pages.dashboard.project.status': 'Project Status Distribution',
  'pages.dashboard.view.details': 'View details',
  'pages.dashboard.monthly.target': 'Monthly Objectives',
  'pages.dashboard.talent.target': 'Talent placement target',
  'pages.dashboard.project.target': 'Project delivery target',
  'pages.dashboard.revenue.target': 'Revenue target',
  'pages.dashboard.recent.activities': 'Recent Activities',
  'pages.dashboard.view.all': 'View all',
  'pages.dashboard.activity': 'Activity',
  'pages.dashboard.name': 'Name',
  'pages.dashboard.time': 'Time',
  'pages.dashboard.status': 'Status',
  'pages.dashboard.completed': 'Completed',
  'pages.dashboard.processing': 'In progress',
  'pages.dashboard.pending': 'Pending',
  'pages.dashboard.quick.actions': 'Quick Actions',
  'pages.dashboard.add.talent': 'Add Talent',
  'pages.dashboard.create.job': 'Create Job',
  'pages.dashboard.add.client': 'Add Client',
  'pages.dashboard.create.project': 'Create Project',
  'pages.dashboard.loading': 'Loading dashboard data...',
  'pages.dashboard.error': 'Failed to load dashboard data',
  'pages.dashboard.retry': 'Retry',
  'pages.dashboard.error.network':
    'Network error. Please check your connection and try again.',
  'pages.dashboard.error.server': 'Server error. Please try again later.',
  'pages.dashboard.error.unauthorized':
    'Authentication failed. Please check your login status.',
  'pages.dashboard.no.data': 'No activity records',
  'pages.dashboard.activity.add.talent': 'New talent added',
  'pages.dashboard.activity.project.update': 'Project updated',
  'pages.dashboard.activity.schedule.interview': 'Interview scheduled',
  'pages.dashboard.activity.send.offer': 'Offer sent',
  'pages.dashboard.activity.candidate.a':
    'Zhang San · Senior Frontend Engineer',
  'pages.dashboard.activity.project.a': 'Frontend Engineer Recruitment',
  'pages.dashboard.activity.candidate.b': 'Li Si · Technical Interview',
  'pages.dashboard.activity.offer.target': 'Wang Wu · Product Manager',
  'pages.dashboard.activity.time.2h': '2 hours ago',
  'pages.dashboard.activity.time.4h': '4 hours ago',
  'pages.dashboard.activity.time.6h': '6 hours ago',
  'pages.dashboard.activity.time.1d': '1 day ago',
  'pages.dashboard.quarter.q1': 'Q1',
  'pages.dashboard.quarter.q2': 'Q2',
  'pages.dashboard.quarter.q3': 'Q3',
  'pages.dashboard.quarter.q4': 'Q4',
  'pages.dashboard.project.status.running': 'In progress',
  'pages.dashboard.project.status.completed': 'Completed',
  'pages.dashboard.project.status.paused': 'Paused',
  'pages.dashboard.project.status.cancelled': 'Cancelled',
  'pages.dashboard.monthly.target.value': '24 / 30',
  'pages.dashboard.project.target.value': '18 / 25',
  'pages.dashboard.revenue.target.value': '¥156K / ¥200K',

  // job
  'pages.job.title': 'Job Management',
  'pages.job.subtitle':
    'Publish, manage and track all job positions in one place.',
  'pages.job.search.placeholder': 'Search by title, client, skills...',
  'pages.job.filter.status': 'Filter by status',
  'pages.job.advanced.search': 'Advanced search',
  'pages.job.add.job': 'Add job',
  'pages.job.status.open': 'Open',
  'pages.job.status.paused': 'Paused',
  'pages.job.status.closed': 'Closed',
  'pages.job.status.completed': 'Completed',
  'pages.job.load.failed': 'Failed to load jobs, please retry later.',
  'pages.job.client.search.failed':
    'Failed to load clients, please retry later.',
  'pages.job.client.search.hint': 'Type to search clients',
  'pages.job.field.client.invalid.uuid':
    'Please select a valid client from the dropdown',
  'pages.job.create.success': 'Job created successfully',
  'pages.job.update.success': 'Job updated successfully',
  'pages.job.save.failed': 'Failed to save the job, please retry later.',
  'pages.job.ai.write': 'AI assist',
  'pages.job.ai.write.tooltip':
    'Generate job description from title and other fields',
  'pages.job.ai.write.failed': 'AI generation failed, please try again later.',
  'pages.job.ai.complete': 'Parse & fill form',
  'pages.job.ai.complete.tooltip':
    'Parse the job description and auto-fill all fields (title, industry, salary, etc.)',
  'pages.job.ai.complete.hint':
    'Paste or type full JD, then click to auto-fill title, industry, salary, etc.',
  'pages.job.ai.complete.failed': 'AI complete failed, please try again later.',
  'pages.job.ai.complete.required': 'Please enter job description first',
  'pages.job.tab.all': 'All',
  'pages.job.items': 'items',
  'pages.job.total.results': 'Total: {total} results',
  'pages.job.no.data': 'No job records',
  'pages.job.modal.edit.title': 'Edit job',
  'pages.job.modal.add.title': 'Add job',
  'pages.job.save': 'Save',
  'pages.job.save.and.create.project': 'Save job & create project',
  'pages.job.cancel': 'Cancel',
  'pages.job.field.title': 'Job title',
  'pages.job.field.title.required': 'Please enter the job title',
  'pages.job.field.title.placeholder': 'Enter job title',
  'pages.job.field.client': 'Client',
  'pages.job.field.client.required': 'Please select a client',
  'pages.job.field.client.placeholder': 'Search client by name',
  'pages.job.field.department': 'Department',
  'pages.job.field.department.required': 'Please enter the department',
  'pages.job.field.department.placeholder': 'Enter department',
  'pages.job.field.level': 'Level',
  'pages.job.field.level.required': 'Please select a level',
  'pages.job.field.level.placeholder': 'Select level',
  'pages.job.level.junior': 'Junior',
  'pages.job.level.middle': 'Middle',
  'pages.job.level.senior': 'Senior',
  'pages.job.level.expert': 'Expert',
  'pages.job.field.location': 'Location',
  'pages.job.field.location.required': 'Please enter the location',
  'pages.job.field.location.placeholder': 'Enter location',
  'pages.job.field.industry': 'Industry',
  'pages.job.field.industry.required': 'Please select an industry',
  'pages.job.field.industry.placeholder': 'Select industry',
  'pages.job.industry.internet': 'Internet',
  'pages.job.industry.finance': 'Finance',
  'pages.job.industry.ecommerce': 'E-commerce',
  'pages.job.industry.education': 'Education',
  'pages.job.industry.construction': 'Construction',
  'pages.job.field.function': 'Function',
  'pages.job.field.function.required': 'Please select a function',
  'pages.job.field.function.placeholder': 'Select function',
  'pages.job.function.tech': 'Technology',
  'pages.job.function.product': 'Product',
  'pages.job.function.operation': 'Operation',
  'pages.job.function.sales': 'Sales',
  'pages.job.field.status': 'Status',
  'pages.job.field.status.required': 'Please select a status',
  'pages.job.field.status.placeholder': 'Select status',
  'pages.job.field.priority': 'Priority',
  'pages.job.field.priority.required': 'Please select a priority',
  'pages.job.field.priority.placeholder': 'Select priority',
  'pages.job.priority.high': 'High',
  'pages.job.priority.medium': 'Medium',
  'pages.job.priority.low': 'Low',
  'pages.job.field.deadline': 'Deadline',
  'pages.job.field.deadline.required': 'Please select the deadline',
  'pages.job.field.deadline.placeholder': 'Pick a date',
  'pages.job.field.salary.range': 'Annual salary range',
  'pages.job.field.salary.range.required': 'Please enter annual salary range',
  'pages.job.field.salary.range.placeholder':
    'Please enter annual salary range',
  'pages.job.field.salary.min': 'Minimum annual salary (10K)',
  'pages.job.field.salary.min.required': 'Please enter minimum annual salary',
  'pages.job.field.salary.min.placeholder': 'Enter minimum annual salary (10K)',
  'pages.job.field.salary.max': 'Maximum annual salary (10K)',
  'pages.job.field.salary.max.required': 'Please enter maximum annual salary',
  'pages.job.field.salary.max.placeholder': 'Enter maximum annual salary (10K)',
  'pages.job.field.famous.company.background': 'Famous company background',
  'pages.job.field.famous.company.background.placeholder':
    'Select famous company background',
  'pages.job.field.nationality': 'Nationality',
  'pages.job.field.nationality.placeholder': 'Select nationality',
  'pages.job.field.first.degree': 'First degree',
  'pages.job.field.first.degree.placeholder': 'Select first degree',
  'pages.job.field.language.proficiency': 'Language proficiency',
  'pages.job.field.language.proficiency.placeholder':
    'Select language proficiency',
  'pages.job.field.age.requirement': 'Age requirement',
  'pages.job.field.age.min.placeholder': 'Minimum age',
  'pages.job.field.age.max.placeholder': 'Maximum age',
  'pages.job.field.work.experience.requirement': 'Work experience requirement',
  'pages.job.field.work.experience.min.placeholder': 'Minimum years',
  'pages.job.field.work.experience.max.placeholder': 'Maximum years',
  'pages.job.field.description': 'Job description',
  'pages.job.field.description.required': 'Please enter job description',
  'pages.job.field.description.placeholder': 'Enter detailed description',
  'pages.job.field.requirements': 'Requirements',
  'pages.job.field.requirements.required': 'Please enter job requirements',
  'pages.job.field.requirements.placeholder': 'Enter requirements',
  'pages.job.detail.load.failed':
    'Failed to load job detail, please try again later.',
  'pages.job.detail.not.found': 'Job record not found.',
  'pages.job.detail.back': 'Back',
  'pages.job.detail.header.subtitle': 'Company · {company}',
  'pages.job.detail.basic.info.section': 'Basic information',
  'pages.job.detail.tab.basic.info': 'Job information',
  'pages.job.detail.created.at': 'Created at',
  'pages.job.detail.updated.at': 'Updated at',
  'pages.job.detail.empty.description': 'No job description has been provided.',
  'pages.job.detail.empty.requirements': 'No requirements have been provided.',
  'pages.job.detail.client.section.title': 'Client information',
  'pages.job.detail.client.empty': 'This job is not linked to a client yet.',
  'pages.job.detail.tab.interviews': 'Interviews',
  'pages.job.detail.interviews.section.title': 'Interview records',
  'pages.job.field.tags': 'Tags',
  'pages.job.field.tags.placeholder': 'Add tags and press Enter',
  'pages.job.interview.list.load.failed': 'Failed to load interview list.',
  'pages.job.interview.delete.success': 'Interview deleted successfully.',
  'pages.job.interview.delete.failed': 'Failed to delete interview.',
  'pages.job.interview.delete.confirm': 'Delete this interview?',
  'pages.job.interview.create': 'Add interview',
  'pages.job.interview.create.first': 'Create the first interview',
  'pages.job.interview.empty': 'No interview records yet',
  'pages.job.interview.edit': 'Edit interview',
  'pages.job.interview.create.success': 'Interview created successfully',
  'pages.job.interview.update.success': 'Interview updated successfully',
  'pages.job.interview.save.failed': 'Failed to save interview',
  'pages.job.interview.type': 'Interview type',
  'pages.job.interview.type.required': 'Please select interview type',
  'pages.job.interview.type.placeholder': 'Select interview type',
  'pages.job.interview.type.phone': 'Phone',
  'pages.job.interview.type.video': 'Video',
  'pages.job.interview.type.face.to.face': 'Face to face',
  'pages.job.interview.type.email': 'Email',
  'pages.job.interview.type.other': 'Other',
  'pages.job.interview.scheduled.date': 'Scheduled time',
  'pages.job.interview.scheduled.date.required': 'Please select scheduled time',
  'pages.job.interview.scheduled.date.placeholder':
    'Pick scheduled date & time',
  'pages.job.interview.actual.date': 'Actual time',
  'pages.job.interview.actual.date.placeholder': 'Pick actual date & time',
  'pages.job.interview.duration': 'Duration (minutes)',
  'pages.job.interview.duration.required': 'Please enter duration',
  'pages.job.interview.duration.placeholder': 'Enter duration in minutes',
  'pages.job.interview.location': 'Location',
  'pages.job.interview.location.tooltip': 'City/venue or meeting link',
  'pages.job.interview.location.placeholder': 'Enter location or meeting link',
  'pages.job.interview.subject': 'Subject',
  'pages.job.interview.subject.required': 'Please enter subject',
  'pages.job.interview.subject.placeholder': 'Enter interview subject',
  'pages.job.interview.content': 'Summary',
  'pages.job.interview.content.required': 'Please enter interview summary',
  'pages.job.interview.content.placeholder': 'Enter summary or highlights',
  'pages.job.interview.key.points': 'Key points',
  'pages.job.interview.key.points.tooltip': 'One point per line; saved as list',
  'pages.job.interview.key.points.placeholder':
    'Enter key points, one per line',
  'pages.job.interview.discussed.salary.range': 'Discussed salary range',
  'pages.job.interview.discussed.salary.range.placeholder':
    'e.g. 30k-45k/month',
  'pages.job.interview.result': 'Result',
  'pages.job.interview.result.placeholder': 'Select result',
  'pages.job.interview.result.success': 'Success',
  'pages.job.interview.result.postponed': 'Postponed',
  'pages.job.interview.result.cancelled': 'Cancelled',
  'pages.job.interview.result.failed': 'Failed',
  'pages.job.interview.discussed.requirements': 'Discussed requirements',
  'pages.job.interview.discussed.requirements.placeholder':
    'Enter requirements discussed',
  'pages.job.interview.discussed.responsibilities':
    'Discussed responsibilities',
  'pages.job.interview.discussed.responsibilities.placeholder':
    'Enter responsibilities discussed',
  'pages.job.interview.discussed.team.info': 'Team info discussed',
  'pages.job.interview.discussed.team.info.placeholder':
    'Team structure, headcount, stakeholders',
  'pages.job.interview.discussed.company.culture': 'Company culture discussed',
  'pages.job.interview.discussed.company.culture.placeholder':
    'Culture, values, working style',
  'pages.job.interview.outcome': 'Outcome',
  'pages.job.interview.outcome.required': 'Please enter outcome',
  'pages.job.interview.outcome.placeholder': 'Enter decision or conclusion',
  'pages.job.interview.next.action': 'Next action',
  'pages.job.interview.next.action.required': 'Please enter next action',
  'pages.job.interview.next.action.placeholder': 'Enter follow-up action',
  'pages.job.interview.next.action.date': 'Next action date',
  'pages.job.interview.next.action.date.placeholder': 'Pick next action date',
  'pages.job.interview.is.important': 'Mark as important',
  'pages.job.interview.client.satisfaction': 'Client satisfaction',
  'pages.job.interview.client.satisfaction.placeholder': '1-5',
  'pages.job.interview.recruiter.rating': 'Consultant rating',
  'pages.job.interview.recruiter.rating.placeholder': '1-5',
  'pages.job.action.edit': 'Edit',
  'pages.job.column.title': 'Job title',
  'pages.job.column.company': 'Company',
  'pages.job.column.level': 'Level',
  'pages.job.column.location': 'Location',
  'pages.job.column.salary': 'Salary range',
  'pages.job.column.priority': 'Priority',
  'pages.job.column.status': 'Status',
  'pages.job.column.deadline': 'Deadline',
  'pages.job.column.actions': 'Actions',
  'pages.job.advanced.search.title': 'Advanced search',
  'pages.job.reset': 'Reset',
  'pages.job.search': 'Search',
  'pages.job.tab.basic.info': 'Basic Info',
  'pages.job.tab.interviews': 'Interviews',
  'pages.job.interviews.section.title': 'Interview Records',
  'pages.job.basic.info.section': 'Basic Information',
  'pages.job.created.at': 'Created At',
  'pages.job.updated.at': 'Updated At',
  'pages.job.empty.description': 'No job description',
  'pages.job.empty.requirements': 'No requirements',
  'pages.job.client.section.title': 'Client Information',
  'pages.job.client.empty': 'No client associated',

  // talent
  'pages.talent.title': 'Talent Management',
  'pages.talent.subtitle':
    'Search, review, and maintain candidate profiles in one place.',
  'pages.talent.search.placeholder': 'Enter keywords separated by spaces...',
  'pages.talent.keyword.match.all': 'All keywords',
  'pages.talent.keyword.match.any': 'Any keyword',
  'pages.talent.filter.status': 'Filter by status',
  'pages.talent.advanced.search': 'Advanced search',
  'pages.talent.add.talent': 'Add talent',
  'pages.talent.items': 'items',
  'pages.talent.no.data': 'No talent records',
  'pages.talent.load.failed': 'Failed to load talents, please retry later.',
  'pages.talent.update.success': 'Talent updated successfully',
  'pages.talent.create.success': 'Talent created successfully',
  'pages.talent.save.failed': 'Failed to save the talent, please retry.',
  'pages.talent.modal.edit.title': 'Edit talent',
  'pages.talent.modal.add.title': 'Add talent',
  'pages.talent.column.name': 'Name',
  'pages.talent.column.position': 'Position',
  'pages.talent.column.company': 'Company',
  'pages.talent.column.contact': 'Contact',
  'pages.talent.column.location': 'Location',
  'pages.talent.column.salary': 'Salary (current / expected)',
  'pages.talent.salary.unknown': 'Not provided',
  'pages.talent.column.status': 'Status',
  'pages.talent.column.owner': 'Owner',
  'pages.talent.column.updated.at': 'Updated at',
  'pages.talent.column.age': 'Age',
  'pages.talent.column.phone': 'Phone',
  'pages.talent.column.tags': 'Tags',
  'pages.talent.column.last.contact': 'Last Contact',
  'pages.talent.column.latest.remark': 'Latest Remark',
  'pages.talent.column.actions': 'Actions',
  'pages.talent.sort.by.recent.contact': 'Sort by recent contact',
  'pages.talent.sort.by.created.time': 'Sort by created time',
  'pages.talent.view.table': 'Table View',
  'pages.talent.view.list': 'List View',
  'pages.talent.column.config': 'Column Settings',
  'pages.talent.column.config.desc':
    'Configure visible columns and their order',
  'pages.talent.column.reset': 'Reset',
  'pages.talent.column.move.up': 'Move Up',
  'pages.talent.column.move.down': 'Move Down',
  'pages.talent.action.edit': 'Edit',
  'pages.talent.action.view': 'View',
  'pages.talent.status.all': 'All statuses',
  'pages.talent.status.active': 'Active',
  'pages.talent.status.inactive': 'Inactive',
  'pages.talent.status.placed': 'Placed',
  'pages.talent.status.blacklisted': 'Blacklisted',
  'pages.talent.field.id': 'ID',
  'pages.talent.field.id.placeholder': 'Enter talent ID',
  'pages.talent.field.name': 'Name',
  'pages.talent.field.name.required': 'Please enter the name',
  'pages.talent.field.name.placeholder': 'Enter name',
  'pages.talent.field.gender': 'Gender',
  'pages.talent.field.gender.placeholder': 'Select gender',
  'pages.talent.field.gender.male': 'Male',
  'pages.talent.field.gender.female': 'Female',
  'pages.talent.field.phone': 'Phone',
  'pages.talent.field.phone.placeholder': 'Enter phone number',
  'pages.talent.field.email': 'Email',
  'pages.talent.field.email.placeholder': 'Enter email address',
  'pages.talent.field.birthdate': 'Birthdate',
  'pages.talent.field.birthdate.placeholder': 'Select birthdate',
  'pages.talent.field.education': 'Education',
  'pages.talent.field.education.placeholder': 'Select education',
  'pages.talent.field.wechat': 'WeChat',
  'pages.talent.field.language': 'Languages',
  'pages.talent.field.language.placeholder': 'Enter language skills',
  'pages.talent.field.hukou': 'Household registration',
  'pages.talent.field.hukou.placeholder': 'Enter hukou',
  'pages.talent.field.intention.city': 'Target city',
  'pages.talent.field.intention.city.placeholder': 'Enter target city',
  'pages.talent.field.current.company': 'Current company',
  'pages.talent.field.current.company.placeholder': 'Enter company name',
  'pages.talent.field.current.position': 'Current position',
  'pages.talent.field.current.position.placeholder': 'Enter position',
  'pages.talent.field.current.salary': 'Current salary',
  'pages.talent.field.current.salary.placeholder': 'Enter salary',
  'pages.talent.field.expected.salary': 'Expected salary',
  'pages.talent.field.expected.salary.placeholder': 'Enter expected salary',
  'pages.talent.field.expected.salary.min': 'Expected salary (min)',
  'pages.talent.field.expected.salary.max': 'Expected salary (max)',
  'pages.talent.field.location': 'Location',
  'pages.talent.field.location.placeholder': 'Enter location',
  'pages.talent.field.status': 'Status',
  'pages.talent.field.status.placeholder': 'Select status',
  'pages.talent.field.skills': 'Skills',
  'pages.talent.field.skills.placeholder': 'Add skills and press Enter',
  'pages.talent.field.tags': 'Tags',
  'pages.talent.field.tags.placeholder': 'Add tags and press Enter',
  'pages.talent.field.age': 'Age',
  'pages.talent.field.age.placeholder': 'Enter age',
  'pages.talent.field.work.experience': 'Work experience',
  'pages.talent.field.work.experience.placeholder':
    'Enter years of work experience',
  'pages.talent.field.notes': 'Notes',
  'pages.talent.field.notes.placeholder': 'Enter notes',
  'pages.talent.field.avatar': 'Avatar',
  'pages.talent.field.avatar.upload': 'Upload avatar',
  'pages.talent.field.avatar.uploading': 'Uploading...',
  'pages.talent.basic.info': 'Basic information',
  'pages.talent.import.parse': 'Parse resume',
  'pages.talent.work.history': 'Work experience',
  'pages.talent.project.experience': 'Project experience',
  'pages.talent.education.experience': 'Education experience',
  'pages.talent.field.project.name': 'Project name',
  'pages.talent.field.project.role': 'Project role',
  'pages.talent.field.school': 'School',
  'pages.talent.field.major': 'Major',
  'pages.talent.field.degree': 'Degree',
  'pages.talent.field.is.fulltime': 'Full-time education',
  'pages.talent.remove': 'Remove',
  'pages.talent.field.company': 'Company',
  'pages.talent.field.department': 'Department',
  'pages.talent.field.position': 'Position',
  'pages.talent.field.start.date': 'Start date',
  'pages.talent.field.end.date': 'End date',
  'pages.talent.field.is.current': 'Current',
  'pages.talent.field.description': 'Description',
  'pages.talent.add.work.history': 'Add work experience',
  'pages.talent.add.project': 'Add project experience',
  'pages.talent.add.education': 'Add education experience',
  'pages.talent.action.save': 'Save',
  'pages.talent.advanced.search.title': 'Talent filters',
  'pages.talent.search': 'Search',
  'pages.talent.cancel': 'Cancel',
  'pages.talent.reset': 'Reset',
  'pages.talent.add.manual': 'Manual entry',
  'pages.talent.add.import': 'Import attachment',
  'pages.talent.collection.add': 'Add to Collection',
  'pages.talent.collection.create': 'Create Collection',
  'pages.talent.collection.edit': 'Edit Collection',
  'pages.talent.collection.delete': 'Delete Collection',
  'pages.talent.collection.name': 'Collection Name',
  'pages.talent.collection.description': 'Description',
  'pages.talent.collection.talent.count': 'Talent Count',
  'pages.talent.collection.select': 'Select Collection',
  'pages.talent.collection.create.new': 'Create New Collection',
  'pages.talent.collection.add.success': 'Added to collection successfully',
  'pages.talent.collection.remove.success':
    'Removed from collection successfully',
  'pages.talent.collection.create.success': 'Collection created successfully',
  'pages.talent.collection.update.success': 'Collection updated successfully',
  'pages.talent.collection.delete.success': 'Collection deleted successfully',
  'pages.talent.collection.delete.confirm':
    'Are you sure you want to delete this collection?',
  'pages.talent.collection.name.required': 'Please enter collection name',
  'pages.talent.collection.load.failed': 'Failed to load collections',
  'pages.talent.import.title': 'Import attachment',
  'pages.talent.import.file.label': 'Resume file',
  'pages.talent.import.file.required': 'Please select a resume file',
  'pages.talent.import.file.hint':
    'Click or drag resume file to this area to upload',
  'pages.talent.import.file.support':
    'Supports PDF, DOC, DOCX, PNG, JPG, JPEG formats, file size not exceeding 20MB',
  'pages.talent.import.uploading': 'Uploading...',
  'pages.talent.import.success': 'File uploaded successfully, parsing...',
  'pages.talent.import.parse.info':
    'Resume parsing feature is under development, please wait',
  'pages.talent.import.failed': 'File upload failed',
  'pages.talent.field.age.min': 'Min age',
  'pages.talent.field.age.max': 'Max age',
  'pages.talent.field.phone.search': 'Phone',
  'pages.talent.field.phone.search.placeholder': 'Enter phone number',
  'pages.talent.field.email.search': 'Email',
  'pages.talent.field.email.search.placeholder': 'Enter email address',
  'pages.talent.field.current.salary.min': 'Current salary (min)',
  'pages.talent.field.current.salary.max': 'Current salary (max)',
  'pages.talent.field.work.experience.min': 'Min years',
  'pages.talent.field.work.experience.max': 'Max years',
  'pages.talent.field.source': 'Source',
  'pages.talent.field.source.placeholder': 'Enter source channel',
  'pages.talent.detail.load.failed':
    'Failed to load talent detail, please try again later.',
  'pages.talent.detail.not.found': 'Talent record not found.',
  'pages.talent.detail.back': 'Back',
  'pages.talent.detail.position.placeholder':
    'No position or company information yet',
  'pages.talent.detail.years.unit': 'years',
  'pages.talent.detail.section.empty': 'No data available',
  'pages.talent.detail.basic.info': 'Candidate information',
  'pages.talent.detail.current.salary': 'Current salary',
  'pages.talent.detail.expected.salary': 'Expected salary',
  'pages.talent.detail.work.experience': 'Work experience',
  'pages.talent.detail.created.at': 'Created at',
  'pages.talent.detail.updated.at': 'Updated at',
  'pages.talent.detail.skills.section': 'Skills',
  'pages.talent.detail.tags.section': 'Tags',
  'pages.talent.detail.tab.basic.info': 'Basic information',
  'pages.talent.detail.tab.attachments': 'Resume attachments',
  'pages.talent.detail.attachments.empty':
    'No resume files have been uploaded yet.',
  'pages.talent.detail.attachments.title': 'Resume attachments',
  'pages.talent.detail.attachments.upload': 'Upload resume',
  'pages.talent.detail.attachments.file.name': 'File name',
  'pages.talent.detail.attachments.type': 'Type',
  'pages.talent.detail.attachments.size': 'Size',
  'pages.talent.detail.attachments.uploaded.at': 'Uploaded at',
  'pages.talent.detail.attachments.primary': 'Primary',
  'pages.talent.detail.attachments.primary.mark': 'Set as primary',
  'pages.talent.detail.attachments.delete': 'Delete',
  'pages.talent.detail.attachments.delete.confirm':
    'Delete this resume attachment?',
  'pages.talent.detail.attachments.upload.success':
    'Resume uploaded successfully.',
  'pages.talent.detail.attachments.upload.failed': 'Failed to upload resume.',
  'pages.talent.detail.attachments.load.failed': 'Failed to load resume list.',
  'pages.talent.detail.download': 'Download',
  'pages.talent.detail.preview': 'Preview',
  'pages.talent.detail.closePreview': 'Close preview',
  'pages.talent.detail.file.size': 'File size',
  'pages.talent.detail.file.type': 'File type',
  'pages.talent.detail.resume.download.failed':
    'Download link is not available.',

  // client
  'pages.client.title': 'Client Management',
  'pages.client.subtitle':
    'Maintain customer data, track relationships, and follow up in time.',
  'pages.client.search.placeholder': 'Search by company, contact, industry...',
  'pages.client.filter.level': 'Filter by level',
  'pages.client.filter.status': 'Filter by status',
  'pages.client.advanced.search': 'Advanced search',
  'pages.client.add.client': 'Add client',
  'pages.client.collection.create': 'Create Collection',
  'pages.client.items': 'items',
  'pages.client.no.data': 'No client records',
  'pages.client.load.failed': 'Failed to load clients, please retry later.',
  'pages.client.update.success': 'Client updated successfully',
  'pages.client.create.success': 'Client created successfully',
  'pages.client.save.failed': 'Failed to save the client, please retry.',
  'pages.client.modal.edit.title': 'Edit client',
  'pages.client.modal.add.title': 'Add client',
  'pages.client.column.company': 'Company',
  'pages.client.column.location': 'Location',
  'pages.client.column.level': 'Level',
  'pages.client.column.status': 'Status',
  'pages.client.column.projects': 'Projects',
  'pages.client.column.revenue': 'Revenue',
  'pages.client.column.owner': 'Owner',
  'pages.client.column.updated.at': 'Updated at',
  'pages.client.column.actions': 'Actions',
  'pages.client.action.view': 'View',
  'pages.client.action.edit': 'Edit',
  'pages.client.action.create.job': 'Create Job',
  'pages.client.action.delete': 'Delete',
  'pages.client.action.save': 'Save',
  'pages.client.delete.confirm.title': 'Delete Client',
  'pages.client.delete.confirm.content':
    'Are you sure you want to delete "{companyName}"? This action cannot be undone.',
  'pages.client.delete.success': 'Client deleted successfully',
  'pages.client.delete.failed': 'Failed to delete client',
  'pages.client.level.all': 'All levels',
  'pages.client.level.a': 'Level A',
  'pages.client.level.b': 'Level B',
  'pages.client.level.c': 'Level C',
  'pages.client.status.all': 'All statuses',
  'pages.client.status.active': 'Active',
  'pages.client.status.potential': 'Potential',
  'pages.client.status.lost': 'Lost',
  'pages.client.field.name': 'Company name',
  'pages.client.field.name.required': 'Please enter the company name',
  'pages.client.field.name.placeholder': 'Enter company name',
  'pages.client.field.industry': 'Industry',
  'pages.client.field.industry.placeholder': 'Enter industry',
  'pages.client.field.source': 'Source',
  'pages.client.field.source.placeholder': 'Select source',
  'pages.client.field.scale': 'Company size',
  'pages.client.field.scale.placeholder': 'Enter size',
  'pages.client.field.level': 'Client level',
  'pages.client.field.level.placeholder': 'Select level',
  'pages.client.field.status': 'Status',
  'pages.client.field.status.placeholder': 'Select status',
  'pages.client.field.city': 'City',
  'pages.client.field.city.placeholder': 'Enter city',
  'pages.client.field.development.stage': 'Development stage',
  'pages.client.field.development.stage.placeholder':
    'Select development stage',
  'pages.client.field.enterprise.nature': 'Enterprise nature',
  'pages.client.field.enterprise.nature.placeholder':
    'Select enterprise nature',
  'pages.client.field.company.type': 'Company type',
  'pages.client.field.company.type.placeholder': 'Select company type',
  'pages.client.field.location': 'Location',
  'pages.client.field.location.placeholder': 'Enter location',
  'pages.client.field.website': 'Website',
  'pages.client.field.website.placeholder': 'Enter website URL',
  'pages.client.field.founded.at': 'Founded at',
  'pages.client.field.business.revenue': 'Business revenue',
  'pages.client.field.financing.status': 'Financing status',
  'pages.client.field.company.overview': 'Company overview',
  'pages.client.field.people.scale.description': 'People scale & structure',
  'pages.client.field.org.structure': 'Org structure & levels',
  'pages.client.field.development.strategy': 'Development strategy',
  'pages.client.field.development.prospect': 'Development outlook',
  'pages.client.field.main.products': 'Main products / businesses',
  'pages.client.field.main.competitors': 'Main competitors',
  'pages.client.field.employer.brand.highlights': 'Employer highlights',
  'pages.client.field.salary.and.benefits': 'Salary & benefits',
  'pages.client.field.commute.and.environment': 'Commute & environment',
  'pages.client.field.tags': 'Tags',
  'pages.client.field.tags.placeholder': 'Add tags and press Enter',
  'pages.client.field.description': 'Company Introduction',
  'pages.client.field.contact.name': 'Contact Name',
  'pages.client.field.contact.name.required': 'Please enter contact name',
  'pages.client.field.contact.name.placeholder': 'Enter contact name',
  'pages.client.field.contact.phone': 'Contact Phone',
  'pages.client.field.contact.phone.required': 'Please enter contact phone',
  'pages.client.field.contact.phone.placeholder': 'Enter phone number',
  'pages.client.field.contact.position': 'Position',
  'pages.client.field.contact.position.placeholder': 'Enter position',
  'pages.client.field.contact.email': 'Email',
  'pages.client.field.contact.email.placeholder': 'Enter email address',
  'pages.client.field.contact.wechat': 'WeChat',
  'pages.client.field.contact.wechat.placeholder': 'Enter WeChat ID',
  'pages.client.advanced.search.title': 'Client filters',
  'pages.client.search': 'Search',
  'pages.client.cancel': 'Cancel',
  'pages.client.company.name': 'Company Name',
  'pages.client.industry': 'Industry',
  'pages.client.scale': 'Company Scale',
  'pages.client.location': 'Location',
  'pages.client.website': 'Website',
  'pages.client.description': 'Description',

  // project
  'pages.project.title': 'Project Management',
  'pages.project.subtitle':
    'Track delivery status, owners, and fulfillment progress for every recruiting project.',
  'pages.project.search.placeholder':
    'Search by name, client, job or recruiter...',
  'pages.project.filter.status': 'Filter by status',
  'pages.project.advanced.search': 'Advanced filters',
  'pages.project.add.project': 'Add project',
  'pages.project.edit.project': 'Edit project',
  'pages.project.load.failed':
    'Failed to load project list, please retry later.',
  'pages.project.load.jobs.failed': 'Failed to load job positions.',
  'pages.project.load.clients.failed': 'Failed to load client list.',
  'pages.project.load.members.failed': 'Failed to load team members.',
  'pages.project.create.success': 'Project created successfully',
  'pages.project.update.success': 'Project updated successfully',
  'pages.project.save.failed': 'Failed to save project, please retry later.',
  'pages.project.items': 'projects',
  'pages.project.no.data': 'No project records',
  'pages.project.jobs.empty': 'No jobs found',
  'pages.project.clients.empty': 'No clients found',
  'pages.project.members.empty': 'No members found',
  'pages.project.modal.save': 'Save',
  'pages.project.modal.cancel': 'Cancel',
  'pages.project.cancel': 'Cancel',
  'pages.project.advanced.title': 'Advanced filters',
  'pages.project.advanced.reset': 'Reset',
  'pages.project.advanced.cancel': 'Cancel',
  'pages.project.advanced.submit': 'Apply',
  'pages.project.column.name': 'Project',
  'pages.project.field.unknown.job': 'Unknown job',
  'pages.project.field.unknown.client': 'Unknown client',
  'pages.project.column.recruiter': 'Owner',
  'pages.project.column.priority': 'Priority',
  'pages.project.column.status': 'Status',
  'pages.project.column.candidates': 'Candidates',
  'pages.project.total.candidates': 'total',
  'pages.project.success.candidates': 'successful',
  'pages.project.column.budget': 'Budget',
  'pages.project.column.deadline': 'Deadline',
  'pages.project.column.progress': 'Progress',
  'pages.project.column.actions': 'Actions',
  'pages.project.action.view': 'View',
  'pages.project.action.edit': 'Edit',
  'pages.project.priority.urgent': 'Urgent',
  'pages.project.priority.high': 'High',
  'pages.project.priority.medium': 'Medium',
  'pages.project.priority.low': 'Low',
  'pages.project.status.planning': 'Planning',
  'pages.project.status.in.progress': 'In progress',
  'pages.project.status.on.hold': 'On hold',
  'pages.project.status.completed': 'Completed',
  'pages.project.status.cancelled': 'Cancelled',
  'pages.project.field.name': 'Project name',
  'pages.project.field.name.required': 'Please enter the project name',
  'pages.project.field.name.placeholder': 'Enter project name',
  'pages.project.field.job': 'Linked job',
  'pages.project.field.job.required': 'Please select a job',
  'pages.project.field.job.placeholder': 'Search job by title or client',
  'pages.project.field.client': 'Client',
  'pages.project.field.client.required': 'Please select a client',
  'pages.project.field.client.placeholder': 'Select client',
  'pages.project.field.client.linked': 'Linked client',
  'pages.project.field.recruiter': 'Owner',
  'pages.project.field.recruiter.required': 'Please select an owner',
  'pages.project.field.recruiter.placeholder': 'Select owner',
  'pages.project.field.priority': 'Priority',
  'pages.project.field.priority.required': 'Please choose a priority',
  'pages.project.field.priority.placeholder': 'Select priority',
  'pages.project.field.status': 'Status',
  'pages.project.field.status.required': 'Please choose a status',
  'pages.project.field.status.placeholder': 'Select status',
  'pages.project.field.start.date': 'Start date',
  'pages.project.field.start.date.required': 'Please select the start date',
  'pages.project.field.start.date.placeholder': 'Pick a start date',
  'pages.project.field.end.date': 'End date',
  'pages.project.field.end.date.required': 'Please select the end date',
  'pages.project.field.end.date.placeholder': 'Pick an end date',
  'pages.project.field.deadline': 'Deadline',
  'pages.project.field.deadline.required': 'Please select the deadline',
  'pages.project.field.deadline.placeholder': 'Pick a deadline',
  'pages.project.field.budget': 'Budget',
  'pages.project.field.budget.required': 'Please enter the budget',
  'pages.project.field.budget.placeholder': 'Enter budget amount',
  'pages.project.field.fee': 'Fee',
  'pages.project.field.fee.required': 'Please enter the fee',
  'pages.project.field.fee.placeholder': 'Enter fee amount',
  'pages.project.field.fee.rate': 'Fee Rate',
  'pages.project.field.fee.rate.placeholder': 'Enter fee rate (0-100%)',
  'pages.project.field.notes': 'Notes',
  'pages.project.field.notes.placeholder': 'Add additional context',
  'pages.project.create.job': 'Create Job',
  'pages.project.create.client': 'Create Client',
  'pages.project.create.job.btn': 'Create Job',
  'pages.project.create.client.btn': 'Create Client',
  'pages.project.recruiter': 'Owner',
  'pages.project.recruiter.required': 'Please select an owner',
  'pages.project.recruiter.placeholder': 'Select owner',
  'pages.project.load.candidates.failed': 'Failed to load candidates',
  'pages.project.load.interviews.failed': 'Failed to load interviews',
  'pages.project.detail.load.failed': 'Failed to load project details',
  'pages.project.detail.load.candidates.failed': 'Failed to load candidates',
  'pages.project.detail.load.interviews.failed': 'Failed to load interviews',
  'pages.project.detail.load.members.failed': 'Failed to load team members',
  'pages.project.detail.load.talents.failed': 'Failed to load talents',
  'pages.project.detail.update.success': 'Project updated successfully',
  'pages.project.detail.update.failed': 'Failed to update project',
  'pages.project.detail.candidate.already.exists':
    'This talent is already in this project, cannot add duplicate',
  'pages.project.detail.add.candidate.success': 'Candidate added successfully',
  'pages.project.detail.add.candidate.failed': 'Failed to add candidate',
  'pages.project.detail.update.status.success': 'Status updated successfully',
  'pages.project.detail.update.status.failed': 'Failed to update status',
  'pages.project.detail.select.candidate.first':
    'Please select a candidate first',
  'pages.project.detail.add.interview.success': 'Interview added successfully',
  'pages.project.detail.add.interview.failed': 'Failed to add interview',
  'pages.project.detail.send.invitation': 'Send Invitation',
  'pages.project.detail.send.invitation.success':
    'Interview invitation sent successfully',
  'pages.project.detail.send.invitation.failed':
    'Failed to send interview invitation',
  'pages.project.detail.actions': 'Actions',
  'pages.project.detail.basic.info': 'Basic Information',
  'pages.project.detail.candidates': 'Candidates',
  'pages.project.detail.interviews': 'Interviews',
  'pages.project.detail.name': 'Project Name',
  'pages.project.detail.status': 'Status',
  'pages.project.detail.priority': 'Priority',
  'pages.project.detail.start.date': 'Start Date',
  'pages.project.detail.end.date': 'End Date',
  'pages.project.detail.deadline': 'Deadline',
  'pages.project.detail.budget': 'Budget',
  'pages.project.detail.fee': 'Fee',
  'pages.project.detail.description': 'Description',
  'pages.project.detail.notes': 'Notes',
  'pages.project.detail.created.at': 'Created At',
  'pages.project.detail.updated.at': 'Updated At',
  'pages.project.detail.total.candidates': 'Total Candidates',
  'pages.project.detail.success.candidates': 'Success Candidates',
  'pages.project.detail.success.rate': 'Success Rate',
  'pages.project.detail.overdue': 'Overdue',
  'pages.project.detail.edit.project': 'Edit Project',
  'pages.project.detail.name.required': 'Please enter project name',
  'pages.project.detail.add.candidate': 'Add Candidate',
  'pages.project.detail.add.candidates.to.project': 'Add Candidates to Project',
  'pages.project.detail.last.contact.record': 'Last Contact Record',
  'pages.project.detail.batch.import': 'Batch Import',
  'pages.project.detail.batch.import.quota.loading':
    'Checking private pool capacity…',
  'pages.project.detail.batch.import.quota.failed':
    'Failed to check private pool capacity. Please retry before uploading.',
  'pages.project.detail.batch.import.quota.retry': 'Retry',
  'pages.project.detail.batch.import.quota.auto.join':
    'Imported candidates will be added to your private pool automatically',
  'pages.project.detail.batch.import.quota.remaining':
    'Private pool: {used}/{limit} used, {remaining} remaining. You can import up to {remaining} resumes.',
  'pages.project.detail.batch.import.quota.unlimited':
    'Private pool: {used} used. Resume uploads are unlimited.',
  'pages.project.detail.batch.import.quota.exceeded':
    'Your private pool has {remaining} slots remaining. Remove files or free up capacity first.',
  'pages.project.detail.batch.import.existing.talent.used':
    'Reused the existing talent, added them to your private pool and linked them to the project',
  'pages.project.detail.batch.import.success':
    'Imported successfully and added to your private pool',
  'pages.project.detail.batch.select.from.collection':
    'Batch Select from Collection',
  'pages.project.detail.select.collection': 'Select Collection',
  'pages.project.detail.select.collection.placeholder':
    'Please select a collection',
  'pages.project.detail.select.collection.first':
    'Please select a collection first',
  'pages.project.detail.search.from.talent.pool': 'Search from Talent Pool',
  'pages.project.detail.export.success': 'Export successful',
  'pages.project.detail.export.failed': 'Export failed',
  'pages.project.detail.export.no.data': 'No data to export',
  'pages.project.detail.export.loading': 'Loading data...',
  'pages.project.detail.generate.recommendation.report':
    'Generate Recommendation Report',
  'pages.project.detail.ai.matching.analysis': 'AI Matching Analysis',
  'pages.project.detail.matching.no.job':
    'Project has no linked job position for matching analysis',
  'pages.project.detail.matching.no.talent': 'Candidate has no linked talent',
  'pages.project.detail.matching.failed': 'AI matching analysis failed',
  'pages.project.detail.more.actions': 'More Actions',
  'pages.project.detail.highlight': 'Highlight',
  'pages.project.detail.help': 'Help',
  'pages.project.detail.batch.update': 'Batch Update',
  'pages.project.detail.batch.remove': 'Batch Remove from Project',
  'pages.project.detail.remove.candidate': 'Remove from Project',
  'pages.project.detail.remove.candidate.confirm.title': 'Confirm Remove',
  'pages.project.detail.remove.candidate.confirm.content':
    'Are you sure you want to remove candidate "{name}" from the project?',
  'pages.project.detail.remove.candidate.success': 'Removed successfully',
  'pages.project.detail.remove.candidate.failed': 'Failed to remove candidate',
  'pages.project.detail.batch.remove.confirm.title': 'Confirm Batch Remove',
  'pages.project.detail.batch.remove.confirm.content':
    'Are you sure you want to remove {count} candidate(s) from the project?',
  'pages.project.detail.batch.remove.success':
    'Removed {count} candidate(s) successfully',
  'pages.project.detail.batch.remove.failed': 'Failed to remove candidates',
  'pages.project.detail.batch.remove.no.selection':
    'Please select candidates to remove',
  'pages.project.detail.all.talent': 'All Talent',
  'pages.project.detail.stage.join.project': 'Join Project',
  'pages.project.detail.stage.recommend.to.client': 'Recommend to Client',
  'pages.project.detail.stage.arrange.client.interview':
    'Arrange Client Interview',
  'pages.project.detail.stage.offer.signed': 'Offer Signed',
  'pages.project.detail.stage.performance.allocation': 'Performance Allocation',
  'pages.project.detail.stage.onboarded': 'Onboarded',
  'pages.project.detail.stage.eliminated': 'Eliminated',
  'pages.project.detail.not.recommended': 'Not Recommended',
  'pages.project.detail.recommended.not.interviewed':
    'Recommended Not Interviewed',
  'pages.project.detail.client.interview': 'Client Interview',
  'pages.project.detail.offer.signed': 'Offer Signed',
  'pages.project.detail.eliminated': 'Eliminated',
  'pages.project.detail.no.permission.view.client':
    'No permission to view this client details',
  'pages.project.detail.no.permission.operate.candidate':
    'No permission to operate this candidate (private talent)',
  'pages.project.detail.no.permission.operate.candidate.short': 'No Permission',
  'pages.project.detail.active.talent': 'Active Talent',
  'pages.project.detail.candidate.name': 'Candidate Name',
  'pages.project.detail.phone': 'Phone',
  'pages.project.detail.stage': 'Stage',
  'pages.project.detail.candidate.status': 'Candidate Status',
  'pages.project.detail.score': 'Score',
  'pages.project.detail.recommended.at': 'Recommended At',
  'pages.project.detail.add.interview': 'Add Interview',
  'pages.project.detail.select.talent': 'Select Talent',
  'pages.project.detail.select.talent.placeholder': 'Please select talent',
  'pages.project.detail.talent.required': 'Please select talent',
  'pages.project.detail.stage.placeholder': 'Enter stage',
  'pages.project.detail.select.candidate': 'Select Candidate',
  'pages.project.detail.select.candidate.placeholder':
    'Please select candidate',
  'pages.project.detail.candidate.required': 'Please select candidate',
  'pages.project.detail.interview.round': 'Interview Round',
  'pages.project.detail.interview.type': 'Interview Type',
  'pages.project.detail.scheduled.date': 'Scheduled Date',
  'pages.project.detail.interview.status': 'Interview Status',
  'pages.project.detail.interview.result': 'Interview Result',
  'pages.project.detail.interview.score': 'Interview Score',
  'pages.project.detail.location': 'Location',
  'pages.project.detail.duration': 'Duration',
  'pages.project.detail.minutes': 'minutes',
  'pages.project.detail.location.placeholder': 'Enter location or link',
  'pages.project.detail.interviewers': 'Interviewers',
  'pages.project.detail.interviewers.placeholder':
    'Enter interviewer information (JSON format)',
  'pages.project.detail.interviewers.invalid.json':
    'Invalid interviewer JSON format, it will be saved as plain text',
  'pages.project.detail.round.required': 'Please enter interview round',
  'pages.project.detail.type.required': 'Please select interview type',
  'pages.project.detail.scheduled.date.required':
    'Please select interview date',
  'pages.project.detail.select.date.time': 'Select Date Time',
  'pages.project.detail.client': 'Client',
  'pages.project.detail.job': 'Job',
  'pages.project.detail.client.info': 'Client Information',
  'pages.project.detail.view.client.detail': 'View Client Detail',
  'pages.project.detail.view.job': 'View Job',
  'pages.project.detail.view.job.detail': 'View Job Detail',
  'pages.project.detail.no.client.info': 'No client information',
  'pages.project.detail.operation.logs': 'Operation Logs',
  'pages.project.detail.ai.match': 'AI Match',
  'pages.project.detail.ai.match.title':
    'Match all talents against job "{jobTitle}"',
  'pages.project.detail.ai.match.desc':
    'First filter with the job description and profile model, then run AI matching on selected talents. Viewing details and adding to the project still follow private-pool permissions.',
  'pages.project.detail.ai.match.no.job':
    'This project has no linked job. Link a job before running AI matching.',
  'pages.project.detail.ai.match.load.failed': 'Failed to load rule matches',
  'pages.project.detail.ai.match.refresh': 'Refresh rule matches',
  'pages.project.detail.ai.match.run.selected':
    'Run AI matching for {count} selected talents',
  'pages.project.detail.ai.match.run.preview':
    'Run AI matching on preview results',
  'pages.project.detail.ai.match.run.one': 'Run AI matching for this talent',
  'pages.project.detail.ai.match.run.success':
    'Analyzed {queued}, skipped {skipped}, failed {failed}',
  'pages.project.detail.ai.match.run.failed': 'AI matching failed',
  'pages.project.detail.ai.match.no.targets':
    'No talents can be analyzed. Select people with permission who have not been analyzed yet.',
  'pages.project.detail.ai.match.no.permission':
    'You do not have private-pool permission for this talent.',
  'pages.project.detail.ai.match.summary':
    'Previewed {total} talents, {analyzed} already analyzed, {pending} pending. At most 20 people per run.',
  'pages.project.detail.ai.match.tab.preview': 'Rule preview ({count})',
  'pages.project.detail.ai.match.tab.analyzed': 'AI matched ({count})',
  'pages.project.detail.ai.match.empty':
    'No matches yet. Refresh the rule preview first.',
  'pages.project.detail.ai.match.name': 'Talent',
  'pages.project.detail.ai.match.location': 'City',
  'pages.project.detail.ai.match.rule.score': 'Rule score',
  'pages.project.detail.ai.match.ai.score': 'AI score',
  'pages.project.detail.ai.match.keywords': 'Matched keywords',
  'pages.project.detail.ai.match.status': 'Status',
  'pages.project.detail.ai.match.analyzed': 'AI matched',
  'pages.project.detail.ai.match.rule.matched': 'Rule matched',
  'pages.project.detail.ai.match.in.project': 'In project',
  'pages.project.detail.ai.match.no.pool.permission': 'No pool permission',
  'pages.project.detail.ai.match.view.analysis': 'View analysis',
  'pages.project.detail.ai.match.add': 'Add to project',
  'pages.project.detail.view.candidate.detail': 'View Candidate Detail',
  'pages.project.detail.talent.position': 'Position',
  'pages.project.detail.offer.date': 'Offer Date',
  'pages.project.detail.join.date': 'Join Date',
  'pages.project.detail.rejection.reason': 'Rejection Reason',
  'pages.project.detail.client.feedback': 'Client Feedback',
  'pages.project.detail.status.history': 'Status Change History',
  'pages.project.detail.no.status.history': 'No status change history',

  // monthly reports
  'pages.monthly.reports.title': 'Monthly Reports',
  'pages.monthly.reports.subtitle':
    'Track monthly recruitment performance and activities',
  'pages.monthly.reports.search.placeholder': 'Search reports',
  'pages.monthly.reports.load.failed': 'Failed to load monthly reports',
  'pages.monthly.reports.empty': 'No monthly reports found',
  'pages.monthly.reports.create': 'Create Monthly Report',
  'pages.monthly.reports.export': 'Export',
  'pages.monthly.reports.view': 'View',
  'pages.monthly.reports.edit': 'Edit',
  'pages.monthly.reports.delete': 'Delete',
  'pages.monthly.reports.delete.confirm':
    'Are you sure you want to delete this monthly report?',
  'pages.monthly.reports.delete.success': 'Monthly report deleted successfully',
  'pages.monthly.reports.delete.failed': 'Failed to delete monthly report',
  'pages.monthly.reports.create.success': 'Monthly report created successfully',
  'pages.monthly.reports.update.success': 'Monthly report updated successfully',
  'pages.monthly.reports.save.failed': 'Failed to save monthly report',
  'pages.monthly.reports.modal.create.title': 'Create Monthly Report',
  'pages.monthly.reports.modal.edit.title': 'Edit Monthly Report',
  'pages.monthly.reports.modal.save': 'Save',
  'pages.monthly.reports.modal.cancel': 'Cancel',
  'pages.monthly.reports.field.month': 'Month',
  'pages.monthly.reports.field.month.required': 'Please select a month',
  'pages.monthly.reports.field.month.placeholder': 'Select month',
  'pages.monthly.reports.field.title': 'Title',
  'pages.monthly.reports.field.title.required': 'Please enter report title',
  'pages.monthly.reports.field.title.placeholder': 'Enter report title',
  'pages.monthly.reports.field.summary': 'Summary',
  'pages.monthly.reports.field.summary.placeholder': 'Enter monthly summary',
  'pages.monthly.reports.field.achievements': 'Key Achievements',
  'pages.monthly.reports.field.achievements.placeholder':
    'Enter key achievements',
  'pages.monthly.reports.field.challenges': 'Challenges',
  'pages.monthly.reports.field.challenges.placeholder': 'Enter challenges',
  'pages.monthly.reports.field.next.plans': 'Next Month Plans',
  'pages.monthly.reports.field.next.plans.placeholder':
    'Enter next month plans',
  'pages.monthly.reports.field.status': 'Status',
  'pages.monthly.reports.field.status.required': 'Please select status',
  'pages.monthly.reports.field.status.placeholder': 'Select status',
  'pages.monthly.reports.field.attachments': 'Attachments',
  'pages.monthly.reports.field.attachments.placeholder': 'Upload attachments',
  'pages.monthly.reports.column.month': 'Month',
  'pages.monthly.reports.column.title': 'Title',
  'pages.monthly.reports.column.status': 'Status',
  'pages.monthly.reports.column.created.by': 'Created By',
  'pages.monthly.reports.column.created.at': 'Created At',
  'pages.monthly.reports.column.updated.at': 'Updated At',
  'pages.monthly.reports.column.actions': 'Actions',
  'pages.monthly.reports.status.draft': 'Draft',
  'pages.monthly.reports.status.submitted': 'Submitted',
  'pages.monthly.reports.status.approved': 'Approved',
  'pages.monthly.reports.status.rejected': 'Rejected',
  'pages.monthly.reports.detail.title': 'Monthly Report Detail',
  'pages.monthly.reports.detail.load.failed':
    'Failed to load monthly report detail',
  'pages.monthly.reports.detail.not.found': 'Monthly report not found',
  'pages.monthly.reports.detail.back': 'Back',
  'pages.monthly.reports.detail.basic.info': 'Basic Information',
  'pages.monthly.reports.detail.content': 'Report Content',
  'pages.monthly.reports.detail.attachments': 'Attachments',
  'pages.monthly.reports.detail.attachments.empty': 'No attachments',
  'pages.monthly.reports.detail.created.by': 'Created By',
  'pages.monthly.reports.detail.created.at': 'Created At',
  'pages.monthly.reports.detail.updated.at': 'Updated At',
  'pages.monthly.reports.detail.view.attachment': 'View Attachment',
  'pages.monthly.reports.detail.download.attachment': 'Download Attachment',
  'pages.monthly.reports.detail.delete.attachment': 'Delete Attachment',
  'pages.monthly.reports.detail.delete.attachment.confirm':
    'Are you sure you want to delete this attachment?',
  'pages.monthly.reports.detail.delete.attachment.success':
    'Attachment deleted successfully',
  'pages.monthly.reports.detail.delete.attachment.failed':
    'Failed to delete attachment',
  'pages.monthly.reports.detail.upload.attachment.success':
    'Attachment uploaded successfully',
  'pages.monthly.reports.detail.upload.attachment.failed':
    'Failed to upload attachment',
  'pages.monthly.reports.detail.upload.attachment.placeholder':
    'Click or drag files to upload',
  'pages.monthly.reports.detail.upload.attachment.support':
    'Supports PDF, DOC, DOCX, XLSX formats',
  'pages.monthly.reports.detail.upload.attachment.size':
    'File size not exceeding 10MB',

  // monthly report this month
  'pages.monthly.report.this.month.title': "This Month's Report",
  'pages.monthly.report.this.month.subtitle':
    "View and update this month's recruitment report",
  'pages.monthly.report.this.month.load.failed':
    "Failed to load this month's report",
  'pages.monthly.report.this.month.save.success': 'Report saved successfully',
  'pages.monthly.report.this.month.save.failed': 'Failed to save report',
  'pages.monthly.report.this.month.status': 'Report Status',
  'pages.monthly.report.this.month.last.updated': 'Last Updated',
  'pages.monthly.report.this.month.overview': 'Monthly Overview',
  'pages.monthly.report.this.month.key.metrics': 'Key Metrics',
  'pages.monthly.report.this.month.talent.acquisition': 'Talent Acquisition',
  'pages.monthly.report.this.month.interview.arrangement':
    'Interview Arrangement',
  'pages.monthly.report.this.month.offer.situation': 'Offer Situation',
  'pages.monthly.report.this.month.revenue.analysis': 'Revenue Analysis',
  'pages.monthly.report.this.month.team.performance': 'Team Performance',
  'pages.monthly.report.this.month.industry.trends': 'Industry Trends',
  'pages.monthly.report.this.month.strategic.adjustments':
    'Strategic Adjustments',
  'pages.monthly.report.this.month.save': 'Save Report',
  'pages.monthly.report.this.month.submit': 'Submit for Approval',
  'pages.monthly.report.this.month.download': 'Download Report',
  'pages.monthly.report.this.month.share': 'Share Report',
  'pages.monthly.report.this.month.metric.total.talents': 'Total Talents',
  'pages.monthly.report.this.month.metric.active.jobs': 'Active Jobs',
  'pages.monthly.report.this.month.metric.successful.placements':
    'Successful Placements',
  'pages.monthly.report.this.month.metric.revenue': 'Revenue',
  'pages.monthly.report.this.month.metric.interview.rate': 'Interview Rate',
  'pages.monthly.report.this.month.metric.offer.rate': 'Offer Rate',
  'pages.monthly.report.this.month.metric.placement.rate': 'Placement Rate',
  'pages.monthly.report.this.month.chart.title.talent':
    'Talent Acquisition Trend',
  'pages.monthly.report.this.month.chart.title.interview':
    'Interview Arrangement Trend',
  'pages.monthly.report.this.month.chart.title.offer': 'Offer Situation Trend',
  'pages.monthly.report.this.month.chart.title.revenue': 'Revenue Trend',
  'pages.monthly.report.this.month.tip.not.started':
    'You haven\'t started this month\'s report yet. Click "Save Report" to create it.',
  'pages.monthly.report.this.month.tip.draft':
    'This is a draft report. You can continue editing and submit it when ready.',
  'pages.monthly.report.this.month.tip.submitted':
    'Report has been submitted for approval. You can no longer edit it.',
  'pages.monthly.report.this.month.tip.approved':
    'Report has been approved. View the final version.',
  'pages.monthly.report.this.month.tip.rejected':
    'Report has been rejected. Please revise and resubmit.',
  'pages.project.detail.load.status.history.failed':
    'Failed to load status change history',
  'pages.project.detail.edit.status.record': 'Edit this record',
  'pages.project.detail.edit.interview': 'Edit Interview',
  'pages.project.detail.edit.status.record.title': 'Edit Status Record',
  'pages.project.detail.business.date': 'Business Date',
  'pages.project.detail.form.data.snapshot': 'Form Data',
  'pages.project.detail.edit.status.record.success': 'Saved',
  'pages.project.detail.recommend.to.client.form.title': 'Recommend to Client',
  'pages.project.detail.recommend.date': 'Recommend Date',
  'pages.project.detail.recommend.channel': 'Recommend Channel',
  'pages.project.detail.recommend.channel.phone': 'Phone',
  'pages.project.detail.recommend.channel.wechat': 'WeChat',
  'pages.project.detail.recommend.channel.email': 'Email',
  'pages.project.detail.recommend.channel.other': 'Other',
  'pages.project.detail.client.contact': 'Client Contact',
  'pages.project.detail.operated.by': 'Operated By',
  'pages.project.detail.recommendation.report': 'Recommendation Report',
  'pages.project.detail.recommendation.report.add': 'Add Recommendation Report',
  'pages.project.detail.recommendation.report.load.failed':
    'Failed to load recommendation reports',
  'pages.project.detail.recommendation.report.delete.success':
    'Deleted successfully',
  'pages.project.detail.recommendation.report.delete.failed':
    'Failed to delete',
  'pages.project.detail.recommendation.report.delete.confirm':
    'Are you sure you want to delete this recommendation report?',
  'pages.project.detail.recommendation.report.type': 'Report Type',
  'pages.project.detail.recommendation.report.status': 'Status',
  'pages.project.detail.recommendation.report.generated.at': 'Generated At',
  'pages.project.detail.recommendation.report.empty':
    'No recommendation reports',
  'pages.project.detail.recommendation.report.create.tip':
    'After selecting a candidate, you will be redirected to the report generation page',
  'pages.project.detail.view': 'View',
  'pages.project.detail.edit': 'Edit',
  'pages.project.detail.delete': 'Delete',
  'pages.project.detail.confirm': 'Confirm',
  'pages.project.detail.cancel': 'Cancel',
  'pages.project.detail.total': 'Total',
  'pages.project.detail.commission.allocation': 'Commission Allocation',
  'pages.project.detail.unknown': 'Unknown',
  'pages.project.detail.email': 'Email',
  'pages.project.detail.recent.contact': 'Recent Contact',
  'pages.project.detail.operation.time': 'Operation Time',
  'pages.project.detail.user': 'User',
  'pages.project.detail.company': 'Company',
  'pages.project.detail.position': 'Position',
  'pages.project.detail.annual.salary': 'Annual Salary',
  'pages.project.detail.age': 'Age',
  'pages.project.detail.tags': 'Tags',
  'pages.project.detail.creator': 'Creator',
  'pages.project.detail.score.unit': 'points',
  'pages.project.detail.round.format': 'Round {round}',
  'pages.project.detail.workflow': 'Project Workflow',
  'pages.project.stage.planning': 'Project Planning',
  'pages.project.stage.planning.desc':
    'Project initialization and requirement confirmation',
  'pages.project.stage.in.progress': 'In Progress',
  'pages.project.stage.in.progress.desc': 'Project execution',
  'pages.project.stage.join.project': 'Join Project',
  'pages.project.stage.join.project.desc': 'Candidate added into project pool',
  'pages.project.stage.recommend.to.client': 'Recommend to Client',
  'pages.project.stage.recommend.to.client.desc':
    'Recommend candidates to client',
  'pages.project.stage.arrange.client.interview': 'Arrange Client Interview',
  'pages.project.stage.arrange.client.interview.desc':
    'Schedule client interviews for candidates',
  'pages.project.stage.offer.signed': 'Offer Signed',
  'pages.project.stage.offer.signed.desc': 'Offer stage progression',
  'pages.project.stage.performance.allocation': 'Performance Allocation',
  'pages.project.stage.performance.allocation.desc':
    'Allocate commission/performance for candidate',
  'pages.project.stage.onboarded': 'Onboarded',
  'pages.project.stage.onboarded.desc': 'Candidate onboarded',
  'pages.project.stage.eliminated': 'Eliminated',
  'pages.project.detail.stage.yellow.order': 'Yellow Order',
  'pages.project.stage.eliminated.desc':
    'Rejected / Withdrawn / Offer Rejected',
  'pages.project.stage.candidate.recommendation': 'Candidate Recommendation',
  'pages.project.stage.candidate.recommendation.desc':
    'Finding and recommending candidates',
  'pages.project.stage.interviewing': 'Interviewing',
  'pages.project.stage.interviewing.desc': 'Candidate interview stage',
  'pages.project.stage.offer.negotiation': 'Offer Negotiation',
  'pages.project.stage.offer.negotiation.desc':
    'Salary negotiation and offer issuance',
  'pages.project.stage.onboarding': 'Onboarding',
  'pages.project.stage.onboarding.desc': 'Candidate onboarding',
  'pages.project.stage.closed': 'Closed',
  'pages.project.stage.closed.desc': 'Rejected / Withdrawn / Offer Rejected',
  'pages.project.detail.no.candidates.in.stage': 'No candidates in this stage',
  'pages.project.detail.stage.filters': 'Stage filters',
  'pages.project.detail.filter.high.risk': 'High risk only',
  'pages.project.detail.filter.high.priority': 'High priority only',
  'pages.project.detail.stage.statuses': 'Statuses',
  'pages.project.detail.advance.action': 'Advance',
  'pages.project.detail.ai.assistant': 'AI Assistant',
  'pages.project.detail.ai.copy.failed': 'Copy failed',
  'pages.project.detail.ai.saved': 'Saved',
  'pages.project.detail.ai.saved.notes': 'Saved notes',
  'pages.project.detail.ai.next.action': 'Next Action',
  'pages.project.detail.ai.next.action.generated':
    'Next action suggestion generated',
  'pages.project.detail.ai.feedback.generated': 'Feedback suggestion generated',
  'pages.project.detail.ai.offer.generated': 'Offer suggestion generated',
  'pages.project.detail.ai.bgcheck.generated':
    'Background-check suggestion generated',
  'pages.project.detail.ai.recommend': 'AI Recommend',
  'pages.project.detail.ai.recommend.modal.title': 'AI Recommendations',
  'pages.project.detail.ai.recommend.generate': 'Regenerate',
  'pages.project.detail.ai.recommend.job.required':
    'Please bind a job before using AI recommendation',
  'pages.project.detail.ai.recommend.failed':
    'Failed to fetch recommendations, please try again later',
  'pages.project.detail.ai.recommend.generated': 'Recommendations updated',
  'pages.project.detail.ai.recommend.stage': 'AI Recommendation',
  'pages.project.detail.match.score': 'Match Score',
  'pages.project.detail.match.reasons': 'Match Reasons',
  'pages.project.detail.min.match.score': 'Min Match Score',
  'pages.project.detail.recommendation.duplicate':
    'The candidate already exists in this project',
  'pages.project.detail.recommendation.add': 'Add to Project',
  'pages.project.detail.ai.analysis': 'Project Analysis',
  'pages.project.detail.generate.analysis': 'Generate Analysis',
  'pages.project.detail.ai.talk.library': 'Talk Library',
  'pages.project.detail.ai.running': 'AI is processing, please wait...',
  'pages.project.detail.ai.no.messages':
    'No conversation history. Click "Generate Analysis" to start AI analysis',
  'pages.project.detail.ai.input.placeholder':
    'Enter your question, press Enter to send, Shift+Enter for new line...',
  'pages.project.detail.ai.you': 'You',
  'pages.project.detail.smart.suggestions': 'Smart Suggestions',
  'pages.project.detail.no.suggestions':
    'No suggestions yet. Click refresh to generate',
  'pages.project.detail.refresh': 'Refresh',
  'pages.project.detail.ai.analysis.failed':
    'AI analysis failed, please try again later',
  'pages.project.detail.ai.suggestions.failed':
    'Failed to generate suggestions, please try again later',
  'pages.project.detail.ai.chat.failed':
    'AI chat failed, please try again later',
  'pages.project.detail.current.stage': 'Current Stage',
  'pages.project.detail.next.action': 'Next Action',
  'pages.project.detail.next.action.hint':
    'Add and track next steps for each candidate',
  'pages.project.detail.record.feedback': 'Record Feedback',
  'pages.project.detail.feedback.failed': 'Failed to record feedback',
  'pages.project.detail.offer.draft': 'Offer Draft',
  'pages.project.detail.background.check': 'Background Check',
  'pages.project.detail.action.schedule': 'Schedule Interview',
  'pages.project.detail.view.talent': 'View Profile',
  'pages.project.detail.next.action.placeholder': 'Next action',
  'pages.project.detail.next.owner.placeholder': 'Owner',
  'pages.project.detail.next.deadline.placeholder': 'Deadline',
  'pages.project.detail.next.action.type': 'Action Type',
  'pages.project.detail.next.action.saved': 'Next action saved (local)',
  'pages.project.detail.next.owner.default': 'Unassigned',
  'pages.project.detail.next.deadline.default': 'No deadline',
  'pages.project.detail.priority.highest': 'P1',
  'pages.project.detail.priority.high': 'P2',
  'pages.project.detail.priority.medium': 'P3',
  'pages.project.detail.priority.low': 'P4',
  'pages.project.detail.risk.high': 'High risk',
  'pages.project.detail.risk.medium': 'Risk',
  'pages.project.detail.risk.rejected': 'Rejected/Withdrawn',
  'pages.project.detail.risk.overdue': 'Overdue >14 days',
  'pages.project.detail.risk.slow': 'Stagnant >7 days',
  'pages.project.detail.risk.interview.stuck': 'Interview stuck',
  'pages.project.detail.risk.offer.delay': 'Offer delay',
  'pages.project.detail.next.action.display':
    'Action: {action} · Owner: {owner} · Deadline: {deadline}',
  'pages.project.detail.metric.count': 'Count',
  'pages.project.detail.metric.avg.days': 'Avg days in stage',
  'pages.project.detail.metric.day': 'd',
  'pages.project.detail.metric.conversion': 'Conversion',
  'pages.project.detail.feedback.placeholder': 'Feedback entry (placeholder)',
  'pages.project.detail.offer.placeholder': 'Offer draft action (placeholder)',
  'pages.project.detail.bgcheck.placeholder':
    'Background check action (placeholder)',
  'pages.project.detail.ai.action.plan': 'Action Plan (Now)',
  'pages.project.detail.ai.interview.prep': 'Interview Prep / Questions',
  'pages.project.detail.ai.salary.talk': 'Salary Talk / Anchors',
  'pages.project.detail.ai.recovery': 'Recovery / Objection Handling',
  'pages.project.detail.ai.action.plan.failed': 'Failed to get action plan',
  'pages.project.detail.ai.interview.prep.failed':
    'Failed to get interview prep',
  'pages.project.detail.ai.salary.failed': 'Failed to get salary talk tips',
  'pages.project.detail.ai.recovery.failed': 'Failed to get recovery talk',
  'pages.project.detail.sign.offer': 'Sign Offer',
  'pages.project.detail.offer.item': 'Item',
  'pages.project.detail.offer.amount': 'Amount (CNY)',
  'pages.project.detail.offer.quantity': 'Quantity',
  'pages.project.detail.offer.total': 'Total',
  'pages.project.detail.offer.remark': 'Remark',
  'pages.project.detail.offer.annual.salary': 'Annual Salary',
  'pages.project.detail.offer.fee.amount': 'Service Fee',
  'pages.project.detail.offer.confirm.date': 'Confirm Date',
  'pages.project.detail.offer.expected.onboard.date': 'Expected Onboard Date',
  'pages.project.detail.offer.status': 'Status',
  'pages.project.detail.offer.consultant': 'Offer Owner',
  'pages.project.detail.offer.notes': 'Notes',
  'pages.project.detail.offer.save.success': 'Offer saved successfully',
  'pages.project.detail.onboard.form.title': 'Onboard',
  'pages.project.detail.onboard.status': 'Status',
  'pages.project.detail.onboard.join.date': 'Join Date',
  'pages.project.detail.onboard.probation.end.date': 'Probation End Date',
  'pages.project.detail.onboard.remind.target': 'Reminder Target',
  'pages.project.detail.onboard.notes': 'Notes',
  'pages.project.detail.onboard.probation.tip':
    'The system will remind you when the probation ends.',
  'pages.project.detail.onboard.save.success':
    'Onboard information saved successfully',

  // candidate
  'pages.candidate.status.added.to.project': 'Added to Project',
  'pages.candidate.status.recommended': 'Recommended',
  'pages.candidate.status.first.interview': 'First Interview',
  'pages.candidate.status.second.interview': 'Second Interview',
  'pages.candidate.status.salary.negotiation': 'Salary Negotiation',
  'pages.candidate.status.offer.sent': 'Offer Sent',
  'pages.candidate.status.offer.accepted': 'Offer Accepted',
  'pages.candidate.status.offer.rejected': 'Offer Rejected',
  'pages.candidate.status.background.check': 'Background Check',
  'pages.candidate.status.joined': 'Joined',
  'pages.candidate.status.rejected': 'Rejected',
  'pages.candidate.status.withdrawn': 'Withdrawn',

  // interview
  'pages.interview.type.phone': 'Phone Interviews',
  'pages.interview.type.video': 'Video Interviews',
  'pages.interview.type.face.to.face': 'Face-to-Face Interviews',
  'pages.interview.type.technical': 'Technical Interview',
  'pages.interview.type.hr': 'HR Interview',
  'pages.interview.type.final': 'Final Interview',
  'pages.interview.status.scheduled': 'Scheduled',
  'pages.interview.status.in.progress': 'In progress',
  'pages.interview.status.completed': 'Completed',
  'pages.interview.status.cancelled': 'Cancelled',
  'pages.interview.status.rescheduled': 'Rescheduled',
  'pages.interview.result.passed': 'Passed',
  'pages.interview.result.failed': 'Failed',
  'pages.interview.result.pending': 'Pending',
  'pages.interview.result.cancelled': 'Cancelled',
  'pages.interview.subtitle': 'Manage and track all {type}',
  'pages.interview.load.failed': 'Failed to load interview list',
  'pages.interview.search.placeholder': 'Search by talent or project name',
  'pages.interview.filter.status.placeholder': 'Filter by status',
  'pages.interview.column.talent.name': 'Talent Name',
  'pages.interview.column.project.name': 'Project Name',
  'pages.interview.column.round': 'Round',
  'pages.interview.round.format': 'Round {round}',
  'pages.interview.column.scheduled.date': 'Scheduled Date',
  'pages.interview.column.location': 'Location',
  'pages.interview.column.status': 'Status',
  'pages.interview.column.result': 'Result',
  'pages.interview.column.score': 'Score',
  'pages.interview.score.format': '{score} points',
  'pages.interview.column.actions': 'Actions',
  'pages.interview.action.view': 'View details',
  'pages.interview.action.edit': 'Edit',
  'pages.interview.action.delete': 'Delete',
  'pages.interview.action.execute': 'Execute',
  'pages.interview.action.more': 'More actions',
  'pages.interview.delete.confirm.title': 'Delete interview',
  'pages.interview.delete.success': 'Interview deleted successfully',
  'pages.interview.delete.failed': 'Failed to delete interview',
  'pages.interview.edit.tip':
    'You can edit the interview details on the project detail page.',
  'pages.interview.create.title': 'Create Interview',
  'pages.interview.create.project': 'Project',
  'pages.interview.create.candidate': 'Candidate',
  'pages.interview.create.round': 'Round',
  'pages.interview.create.type': 'Interview Type',
  'pages.interview.create.scheduled.date': 'Scheduled Time',
  'pages.interview.create.duration': 'Duration (minutes)',
  'pages.interview.create.location': 'Location',
  'pages.interview.create.status': 'Status',
  'pages.interview.create.project.placeholder': 'Select a project',
  'pages.interview.create.candidate.placeholder': 'Select a candidate',
  'pages.interview.candidate.in.other.pool': "In other's private pool",
  'pages.job.client.in.other.pool':
    "This client belongs to other's private pool",
  'pages.client.add.to.private.pool.success':
    'Client added to your private pool',
  'pages.interview.create.round.required': 'Please enter interview round',
  'pages.interview.create.type.required': 'Please select interview type',
  'pages.interview.create.scheduled.date.required':
    'Please select scheduled time',
  'pages.interview.create.scheduled.date.placeholder': 'Select scheduled time',
  'pages.interview.create.success': 'Interview created successfully',
  'pages.interview.create.failed': 'Failed to create interview',
  'pages.interview.total.results': 'Total: {total} results',
  'pages.interview.pagination.total': '{start}-{end} of {total}',
  'pages.interview.no.data': 'No interview records',
  'pages.interview.date.start': 'Start date',
  'pages.interview.date.end': 'End date',

  // question
  'pages.question.title': 'Expert Q&A Board',
  'pages.question.subtitle':
    'Search, ask, and manage knowledge content shared by recruiters.',
  'pages.question.my.answers.title': 'My Answers',
  'pages.question.my.answers.subtitle':
    'Review every answer you contributed to the community.',
  'pages.question.categories.title': 'Question Categories',
  'pages.question.categories.subtitle':
    'Organize topics, keep the knowledge base clean and easy to browse.',
  'pages.question.add.question': 'Create question',
  'pages.question.categories.add': 'Add category',
  'pages.question.search.placeholder': 'Search by title, keyword or tag...',
  'pages.question.filter.category': 'Filter by category',
  'pages.question.filter.status': 'Filter by status',
  'pages.question.filter.priority': 'Filter by priority',
  'pages.question.filter.sort': 'Sort by',
  'pages.question.sort.latest': 'Latest',
  'pages.question.sort.hot': 'Hot',
  'pages.question.sort.unanswered': 'Unanswered',
  'pages.question.sort.resolved': 'Resolved',
  'pages.question.column.title': 'Question',
  'pages.question.column.category': 'Category',
  'pages.question.column.status': 'Status',
  'pages.question.column.priority': 'Priority',
  'pages.question.column.answers': 'Answers',
  'pages.question.column.views': 'Views',
  'pages.question.column.stats': 'Stats',
  'pages.question.column.created.at': 'Created at',
  'pages.question.column.updated.at': 'Updated at',
  'pages.question.column.actions': 'Actions',
  'pages.question.action.edit': 'Edit',
  'pages.question.action.delete': 'Delete',
  'pages.question.delete.confirm':
    'Are you sure you want to delete this question?',
  'pages.question.delete.ok': 'Delete',
  'pages.question.delete.cancel': 'Cancel',
  'pages.question.delete.success': 'Question deleted',
  'pages.question.delete.failed':
    'Failed to delete the question, please retry later.',
  'pages.question.load.failed': 'Failed to load questions, please retry later.',
  'pages.question.categories.load.failed':
    'Failed to load categories, please retry later.',
  'pages.question.answers.load.failed':
    'Failed to load answers, please retry later.',
  'pages.question.items': 'items',
  'pages.question.items.suffix': 'questions',
  'pages.question.no.data': 'No data yet',
  'pages.question.category.unknown': 'Uncategorized',
  'pages.question.top': 'Top',
  'pages.question.anonymous': 'Anonymous',
  'pages.question.category.required': 'Please create a category first',
  'pages.question.interaction.failed': 'Operation failed, please retry later',
  'pages.question.update.success': 'Question updated',
  'pages.question.create.success': 'Question created',
  'pages.question.modal.add.title': 'Create question',
  'pages.question.modal.edit.title': 'Edit question',
  'pages.question.modal.save': 'Save',
  'pages.question.modal.cancel': 'Cancel',
  'pages.question.field.title': 'Title',
  'pages.question.field.title.required': 'Please enter the question title',
  'pages.question.field.title.placeholder': 'Enter question title',
  'pages.question.field.content': 'Description',
  'pages.question.field.content.required': 'Please describe the question',
  'pages.question.field.content.placeholder': 'Provide background and details',
  'pages.question.field.category': 'Category',
  'pages.question.field.category.required': 'Please choose a category',
  'pages.question.field.category.placeholder': 'Select category',
  'pages.question.field.priority': 'Priority',
  'pages.question.field.priority.required': 'Please choose a priority',
  'pages.question.field.priority.placeholder': 'Select priority',
  'pages.question.field.privacy': 'Privacy',
  'pages.question.field.reward': 'Reward points',
  'pages.question.field.reward.placeholder': 'Optional reward points',
  'pages.question.field.tags': 'Tags',
  'pages.question.field.tags.placeholder': 'Add tags and press Enter',
  'pages.question.privacy.public': 'Public',
  'pages.question.privacy.private': 'Invite only',
  'pages.question.save.success': 'Question saved',
  'pages.question.save.failed':
    'Failed to save the question, please retry later.',
  'pages.question.status.pending': 'Pending',
  'pages.question.status.answered': 'Answered',
  'pages.question.status.resolved': 'Resolved',
  'pages.question.status.closed': 'Closed',
  'pages.question.priority.low': 'Low',
  'pages.question.priority.normal': 'Normal',
  'pages.question.priority.high': 'High',
  'pages.question.priority.urgent': 'Urgent',
  'pages.question.ai.answer.failed':
    'Failed to get AI answer, please retry later',
  'pages.question.ai.answer.invalid': 'Question and answer cannot be empty',
  'pages.question.ai.answer.saved': 'Question and answer saved',
  'pages.question.ai.question.invalid': 'Question cannot be empty',
  'pages.question.ai.answer.title': 'AI Smart Answer',
  'pages.question.ai.answer.accept': 'Accept as answer',
  'pages.question.ai.answer.reject': 'Reject',
  'pages.question.ai.answer.save': 'Save as question',
  'pages.question.ai.answer.no.result': 'No one has asked this question yet',
  'pages.question.ai.answer.description':
    'The system has searched for related questions for you, but no matching results were found. Here is the answer generated by AI for you:',
  'pages.question.ai.answer.question': 'Question',
  'pages.question.ai.answer.answer': 'Answer',
  'pages.question.ai.answer.loading': 'AI is thinking...',
  'pages.question.ai.answer.empty': 'No answer content yet',
  'pages.question.my.answers.column.question': 'Question',
  'pages.question.my.answers.column.content': 'Answer content',
  'pages.question.my.answers.column.upvotes': 'Upvotes',
  'pages.question.my.answers.column.status': 'Status',
  'pages.question.my.answers.column.stats': 'Insights',
  'pages.question.my.answers.column.created.at': 'Answered at',
  'pages.question.my.answers.column.actions': 'Actions',
  'pages.question.my.answers.search.placeholder':
    'Search by question title or content...',
  'pages.question.my.answers.sort.placeholder': 'Sort by',
  'pages.question.my.answers.sort.latest': 'Latest answers',
  'pages.question.my.answers.sort.upvotes': 'Most upvotes',
  'pages.question.my.answers.sort.accepted': 'Accepted answers',
  'pages.question.my.answers.status.best': 'Best answer',
  'pages.question.my.answers.status.accepted': 'Accepted',
  'pages.question.my.answers.status.normal': 'Pending review',
  'pages.question.my.answers.stats.upvotes': 'Upvotes',
  'pages.question.my.answers.stats.comments': 'Comments',
  'pages.question.my.answers.stats.views': 'Views',
  'pages.question.my.answers.action.view': 'View question',
  'pages.question.my.answers.action.edit': 'Edit',
  'pages.question.my.answers.action.delete': 'Delete',
  'pages.question.my.answers.delete.confirm':
    'Are you sure you want to delete this answer?',
  'pages.question.my.answers.delete.success': 'Answer deleted',
  'pages.question.my.answers.delete.failed': 'Failed to delete the answer.',
  'pages.question.my.answers.edit.modal.title': 'Edit answer',
  'pages.question.my.answers.field.content': 'Answer content',
  'pages.question.my.answers.field.content.required':
    'Please enter your answer',
  'pages.question.my.answers.field.content.placeholder':
    'Share your solution or experience...',
  'pages.question.my.answers.save.success': 'Answer updated',
  'pages.question.my.answers.save.failed': 'Failed to update the answer.',
  'pages.question.my.answers.load.failed':
    'Failed to load your answers, please retry later.',
  'pages.question.my.answers.empty.text':
    'You have not answered any questions yet.',
  'pages.question.categories.column.name': 'Category',
  'pages.question.categories.column.code': 'Code',
  'pages.question.categories.column.description': 'Description',
  'pages.question.categories.column.icon': 'Icon',
  'pages.question.categories.column.sort': 'Sort order',
  'pages.question.categories.column.count': 'Questions',
  'pages.question.categories.column.status': 'Status',
  'pages.question.categories.column.actions': 'Actions',
  'pages.question.categories.status.active': 'Active',
  'pages.question.categories.status.inactive': 'Disabled',
  'pages.question.categories.action.edit': 'Edit',
  'pages.question.categories.action.delete': 'Delete',
  'pages.question.categories.delete.confirm': 'Delete this category?',
  'pages.question.categories.delete.success': 'Category deleted',
  'pages.question.categories.delete.failed': 'Failed to delete the category.',
  'pages.question.categories.empty': 'No categories yet',
  'pages.question.categories.modal.add.title': 'Add category',
  'pages.question.categories.modal.edit.title': 'Edit category',
  'pages.question.categories.field.name': 'Category name',
  'pages.question.categories.field.name.required':
    'Please enter the category name',
  'pages.question.categories.field.name.placeholder': 'Enter category name',
  'pages.question.categories.field.code': 'Code',
  'pages.question.categories.field.code.required': 'Please enter the code',
  'pages.question.categories.field.code.placeholder': 'Enter code',
  'pages.question.categories.field.description': 'Description',
  'pages.question.categories.field.description.placeholder': 'Add description',
  'pages.question.categories.field.icon': 'Icon',
  'pages.question.categories.field.icon.placeholder': 'Icon name or URL',
  'pages.question.categories.field.sort': 'Sort order',
  'pages.question.categories.field.sort.placeholder':
    'Lower numbers appear first',
  'pages.question.categories.field.parent': 'Parent category',
  'pages.question.categories.field.parent.placeholder':
    'Select parent category (optional)',
  'pages.question.categories.field.active': 'Active status',
  'pages.question.categories.save.success': 'Category saved',
  'pages.question.categories.save.failed': 'Failed to save the category.',
  'pages.question.categories.search.placeholder':
    'Search category name or code...',
  'pages.question.categories.refresh': 'Refresh',
  'pages.question.categories.total.prefix': 'Total',
  'pages.question.detail.title': 'Question detail',
  'pages.question.detail.subtitle':
    'Dive into the full context, best answers, and team discussions.',
  'pages.question.detail.back': 'Back to list',
  'pages.question.detail.load.failed': 'Failed to load question detail.',
  'pages.question.detail.answers.load.failed':
    'Failed to load answers, please retry later.',
  'pages.question.detail.answer.success': 'Answer submitted',
  'pages.question.detail.answer.failed': 'Failed to submit the answer.',
  'pages.question.detail.comment.success': 'Comment submitted',
  'pages.question.detail.comment.failed': 'Failed to submit the comment.',
  'pages.question.detail.interaction.failed':
    'Operation failed, please retry later.',
  'pages.question.detail.best.confirm.title':
    'Set this answer as the best answer?',
  'pages.question.detail.submit': 'Confirm',
  'pages.question.detail.cancel': 'Cancel',
  'pages.question.detail.best.success': 'Best answer updated',
  'pages.question.detail.best.failed': 'Failed to set the best answer.',
  'pages.question.detail.delete.success': 'Answer deleted',
  'pages.question.detail.delete.failed': 'Failed to delete the answer.',
  'pages.question.detail.anonymous': 'Anonymous user',
  'pages.question.detail.reward.prefix': 'Reward',
  'pages.question.detail.like': 'Upvote',
  'pages.question.detail.collect': 'Collect',
  'pages.question.detail.answer': 'Answer',
  'pages.question.detail.ai.answer': 'AI answer',
  'pages.question.detail.ai.answer.success':
    'AI draft is ready, please review before submitting.',
  'pages.question.detail.ai.answer.failed':
    'Failed to generate AI answer, please retry later.',
  'pages.question.detail.ai.answer.empty':
    'AI did not return content, please try again.',
  'pages.question.detail.not.found': 'Question not found',
  'pages.question.detail.answers.title': 'Answers',
  'pages.question.detail.answers.empty':
    'No one has answered this question yet.',
  'pages.question.detail.comment': 'Comment',
  'pages.question.detail.mark.best': 'Mark as best answer',
  'pages.question.detail.best.badge': 'Best answer',
  'pages.question.detail.delete': 'Delete',
  'pages.question.detail.answer.modal.title': 'Write your answer',
  'pages.question.detail.field.content': 'Answer content',
  'pages.question.detail.field.content.required': 'Please enter your answer',
  'pages.question.detail.field.content.placeholder':
    'Share your detailed solution...',
  'pages.question.detail.field.anonymous': 'Anonymous answer',
  'pages.question.detail.field.anonymous.label': 'Publish anonymously',
  'pages.question.detail.comment.modal.title': 'Write a comment',
  'pages.question.detail.comment.field': 'Comment content',
  'pages.question.detail.comment.field.required': 'Please enter your comment',
  'pages.question.detail.comment.field.placeholder':
    'Share your insights or ask for details',

  // analytic
  'pages.analytic.overview.title': 'Data Overview',
  'pages.analytic.overview.subtitle':
    'Comprehensive data analysis and business trend display',
  'pages.analytic.loading': 'Loading analytics data...',
  'pages.analytic.total.talents': 'Total Talents',
  'pages.analytic.total.jobs': 'Total Jobs',
  'pages.analytic.total.clients': 'Total Clients',
  'pages.analytic.total.projects': 'Total Projects',
  'pages.analytic.time.range.week': 'Last Week',
  'pages.analytic.time.range.month': 'Last Month',
  'pages.analytic.time.range.quarter': 'Last Quarter',
  'pages.analytic.time.range.year': 'Last Year',
  'pages.analytic.refresh': 'Refresh',
  'pages.analytic.export.report': 'Export Report',
  'pages.analytic.project.success.rate': 'Project Success Rate',
  'pages.analytic.average.cycle.time': 'Average Cycle Time',
  'pages.analytic.day.unit': 'days',
  'pages.analytic.average.cycle.time.desc':
    'Average time from project start to completion',
  'pages.analytic.projects.average.cycle.time': 'Average Cycle Time',
  'pages.analytic.projects.average.cycle.time.desc':
    'Average time from project start to completion',
  'pages.analytic.data.trend.analysis': 'Data Trend Analysis',
  'pages.analytic.success.rate.trend': 'Success Rate Trend',
  'pages.analytic.success.rate': 'Success Rate',
  'pages.analytic.jobs.title': 'Job Analytics',
  'pages.analytic.jobs.subtitle':
    'Job data statistics and distribution analysis',
  'pages.analytic.jobs.total': 'Total Jobs',
  'pages.analytic.jobs.active': 'Active Jobs',
  'pages.analytic.jobs.paused': 'Paused',
  'pages.analytic.jobs.closed': 'Closed',
  'pages.analytic.jobs.success.rate': 'Success Rate',
  'pages.analytic.jobs.status.open': 'In Progress',
  'pages.analytic.jobs.status.paused': 'Paused',
  'pages.analytic.jobs.status.closed': 'Closed',
  'pages.analytic.jobs.status.draft': 'Draft',
  'pages.analytic.jobs.status.distribution': 'Job Status Distribution',
  'pages.analytic.jobs.industry.distribution': 'Industry Distribution Top 10',
  'pages.analytic.jobs.priority.distribution': 'Priority Distribution',
  'pages.analytic.jobs.location.distribution': 'Location Distribution Top 10',
  'pages.analytic.jobs.creation.trend': 'Job Creation and Close Trend',
  'pages.analytic.jobs.new': 'New Jobs',
  'pages.analytic.jobs.top': 'Top Jobs Top 10',
  'pages.analytic.jobs.table.title': 'Job Title',
  'pages.analytic.jobs.table.company': 'Company',
  'pages.analytic.jobs.table.candidates': 'Candidates',
  'pages.analytic.jobs.table.success': 'Success Count',
  'pages.analytic.jobs.table.created.at': 'Created At',
  'pages.analytic.jobs.loading': 'Loading...',
  'pages.analytic.jobs.refresh': 'Refresh',
  'pages.analytic.jobs.export.report': 'Export Report',
  'pages.analytic.jobs.time.range.week': 'This Week',
  'pages.analytic.jobs.time.range.month': 'This Month',
  'pages.analytic.jobs.time.range.quarter': 'This Quarter',
  'pages.analytic.jobs.time.range.year': 'This Year',
  'pages.analytic.talents.title': 'Talent Analytics',
  'pages.analytic.talents.subtitle':
    'Talent database statistics and distribution analysis',
  'pages.analytic.talents.total': 'Total Talents',
  'pages.analytic.talents.active': 'Active Talents',
  'pages.analytic.talents.average.experience': 'Average Experience',
  'pages.analytic.talents.blacklisted': 'Blacklisted',
  'pages.analytic.talents.status.active': 'Active',
  'pages.analytic.talents.status.inactive': 'Inactive',
  'pages.analytic.talents.status.blacklisted': 'Blacklisted',
  'pages.analytic.talents.status.distribution': 'Talent Status Distribution',
  'pages.analytic.talents.source.distribution': 'Source Distribution Top 10',
  'pages.analytic.talents.experience.distribution': 'Experience Distribution',
  'pages.analytic.talents.location.distribution':
    'Location Distribution Top 10',
  'pages.analytic.talents.growth.trend': 'Talent Growth Trend',
  'pages.analytic.talents.new': 'New Talents',
  'pages.analytic.talents.top.skills': 'Top Skills Top 10',
  'pages.analytic.talents.no.skills': 'No skill data available',
  'pages.analytic.year.unit': 'years',
  'pages.analytic.clients.title': 'Client Analytics',
  'pages.analytic.clients.subtitle':
    'Client data statistics and distribution analysis',
  'pages.analytic.clients.total': 'Total Clients',
  'pages.analytic.clients.active': 'Active Clients',
  'pages.analytic.clients.vip': 'VIP Clients',
  'pages.analytic.clients.avg.projects': 'Average Projects',
  'pages.analytic.clients.level.s': 'S级',
  'pages.analytic.clients.level.a': 'A级',
  'pages.analytic.clients.level.b': 'B级',
  'pages.analytic.clients.level.c': 'C级',
  'pages.analytic.clients.level.d': 'D级',
  'pages.analytic.clients.level.distribution': 'Client Level Distribution',
  'pages.analytic.clients.industry.distribution':
    'Industry Distribution Top 10',
  'pages.analytic.clients.growth.trend': 'Client Growth Trend',
  'pages.analytic.clients.new': 'New Clients',
  'pages.analytic.clients.top.performance': 'Top Client Performance',
  'pages.analytic.clients.table.company': 'Company Name',
  'pages.analytic.clients.table.projects': 'Projects',
  'pages.analytic.clients.table.success': 'Success Projects',
  'pages.analytic.clients.table.revenue': 'Total Revenue',
  'pages.analytic.projects.title': 'Project Analytics',
  'pages.analytic.projects.subtitle':
    'Project data statistics and progress analysis',
  'pages.analytic.projects.total': 'Total Projects',
  'pages.analytic.projects.in.progress': 'In Progress',
  'pages.analytic.projects.completed': 'Completed',
  'pages.analytic.projects.avg.cycle': 'Average Cycle',
  'pages.analytic.projects.status.in.progress': 'In Progress',
  'pages.analytic.projects.status.completed': 'Completed',
  'pages.analytic.projects.status.cancelled': 'Cancelled',
  'pages.analytic.projects.status.pending': 'Pending',
  'pages.analytic.projects.interview.passed': 'Passed',
  'pages.analytic.projects.interview.failed': 'Failed',
  'pages.analytic.projects.interview.pending': 'Pending',
  'pages.analytic.projects.interview.pass.rate': 'Interview Pass Rate',
  'pages.analytic.projects.success.rate': 'Success Rate',
  'pages.analytic.projects.status.distribution': 'Project Status Distribution',
  'pages.analytic.projects.interview.type.distribution':
    'Interview Type Distribution',
  'pages.analytic.projects.interview.result.distribution':
    'Interview Result Distribution',
  'pages.analytic.projects.creation.trend':
    'Project Creation and Completion Trend',
  'pages.analytic.projects.new': 'New Projects',
  'pages.analytic.work.title': 'Work Analytics',
  'pages.analytic.work.subtitle': 'Personal and team productivity insights',
  'pages.analytic.work.load.error': 'Failed to load work analytics data',
  'pages.analytic.work.tab.personal': 'Personal View',
  'pages.analytic.work.tab.team': 'Team View',
  'pages.analytic.work.card.uploads': 'Resume Uploads',
  'pages.analytic.work.card.valid': 'Valid Resumes',
  'pages.analytic.work.card.views': 'Views',
  'pages.analytic.work.card.submissions': 'Submissions',
  'pages.analytic.work.card.interviews': 'Interviews',
  'pages.analytic.work.card.offers': 'Offers',
  'pages.analytic.work.card.hires': 'Hires',
  'pages.analytic.work.card.revenue': 'GMV (k)',
  'pages.analytic.work.funnel.title': 'Funnel Overview',
  'pages.analytic.work.stage': 'Stage',
  'pages.analytic.work.stage.volume': 'Volume',
  'pages.analytic.work.stage.conversion': 'Conversion',
  'pages.analytic.work.stage.cycle': 'Avg Cycle',
  'pages.analytic.work.stage.upload': 'Upload',
  'pages.analytic.work.stage.valid': 'Valid',
  'pages.analytic.work.stage.submit': 'Submission',
  'pages.analytic.work.stage.interview': 'Interview',
  'pages.analytic.work.stage.offer': 'Offer',
  'pages.analytic.work.stage.hire': 'Hire',
  'pages.analytic.work.trend.title': 'Pipeline Trend',
  'pages.analytic.work.trend.day': 'Day',
  'pages.analytic.work.team.title': 'Team Ranking',
  'pages.analytic.work.col.name': 'Name',
  'pages.analytic.work.col.role': 'Role',
  'pages.analytic.work.col.uploads': 'Uploads',
  'pages.analytic.work.col.submissions': 'Submissions',
  'pages.analytic.work.col.interviews': 'Interviews',
  'pages.analytic.work.col.offers': 'Offers',
  'pages.analytic.work.col.hires': 'Hires',
  'pages.analytic.work.col.conversion': 'Hire Conversion',
  'pages.analytic.work.col.revenue': 'Revenue',
  'pages.analytic.work.personal.title': 'Goals & Progress',
  'pages.analytic.work.goal.upload': 'Upload goal',
  'pages.analytic.work.goal.submit': 'Submission goal',
  'pages.analytic.work.goal.interview': 'Interview goal',
  'pages.analytic.work.goal.offer': 'Offer goal',
  'pages.analytic.work.goal.hire': 'Hire goal',
  'pages.analytic.work.goal.tip': 'Current vs target',
  'pages.analytic.work.alerts.title': 'Insights',
  'pages.analytic.work.alert.slow.funnel':
    'Interview cycle slower than average',
  'pages.analytic.work.alert.slow.funnel.desc':
    'Average interview cycle is 3.1d, slower than target 2.5d. Consider tightening follow-up cadence.',
  'pages.analytic.work.alert.goal.gap': 'Offer conversion below target',
  'pages.analytic.work.alert.goal.gap.desc':
    'Offer to hire conversion is 14%, target is 18%. Focus on offer alignment and candidate commitment.',
  'pages.analytic.work.me': 'Me',
  'pages.analytic.work.role.consultant': 'Consultant',
  'pages.analytic.work.role.manager': 'Manager',

  // daily
  'pages.daily.reports.today.title': "Today's Daily Report",
  'pages.daily.reports.all.title': 'All Daily Reports',
  'pages.daily.reports.all.subtitle':
    'View and manage all historical daily report records',
  'pages.daily.reports.loading': 'Loading daily report...',
  'pages.daily.reports.load.failed': 'Failed to load daily report',
  'pages.daily.reports.auto.created': 'Daily report auto-created successfully',
  'pages.daily.reports.create.failed': 'Failed to create daily report',
  'pages.daily.reports.save.success': 'Saved successfully',
  'pages.daily.reports.save.failed': 'Failed to save',
  'pages.daily.reports.submit.success': 'Submitted successfully',
  'pages.daily.reports.submit.failed': 'Failed to submit',
  'pages.daily.reports.list.load.failed': 'Failed to load daily reports list',
  'pages.daily.reports.detail.load.failed':
    'Failed to load daily report detail',
  'pages.daily.reports.delete.success': 'Deleted successfully',
  'pages.daily.reports.delete.failed': 'Failed to delete',
  'pages.daily.reports.delete.confirm.title': 'Confirm Delete',
  'pages.daily.reports.delete.confirm.content':
    'Are you sure you want to delete the daily report for {date}?',
  'pages.daily.reports.no.data': 'No data available',
  'pages.daily.reports.date.format': 'YYYY-MM-DD',
  'pages.daily.reports.status.draft': 'Draft',
  'pages.daily.reports.status.submitted': 'Submitted',
  'pages.daily.reports.status.archived': 'Archived',
  'pages.daily.reports.stat.jobs': 'Jobs',
  'pages.daily.reports.stat.talents': 'Talents',
  'pages.daily.reports.stat.clients': 'Clients',
  'pages.daily.reports.stat.projects': 'Projects',
  'pages.daily.reports.stat.jobs.detail':
    'Updated: {updated} | Interviews: {interviews}',
  'pages.daily.reports.stat.talents.detail':
    'Communications: {communications} | Recommended: {recommended}',
  'pages.daily.reports.stat.clients.detail':
    'Communications: {communications} | Interviews: {interviews}',
  'pages.daily.reports.stat.projects.detail':
    'Recommended: {recommended} | Completed: {completed}',
  'pages.daily.reports.unit.count': 'items',
  'pages.daily.reports.unit.person': 'people',
  'pages.daily.reports.unit.article': 'articles',
  'pages.daily.reports.unit.post': 'posts',
  'pages.daily.reports.questions.stats': 'Question Master Statistics',
  'pages.daily.reports.questions.asked': 'Questions Asked',
  'pages.daily.reports.questions.answered': 'Questions Answered',
  'pages.daily.reports.articles': 'Articles',
  'pages.daily.reports.posts': 'Posts',
  'pages.daily.reports.work.content': 'Work Content',
  'pages.daily.reports.auto.summary': 'Auto-generated Summary',
  'pages.daily.reports.no.summary': 'No summary available',
  'pages.daily.reports.notes': 'Notes',
  'pages.daily.reports.notes.placeholder': "Please add today's work notes...",
  'pages.daily.reports.save': 'Save',
  'pages.daily.reports.submit': 'Submit',
  'pages.daily.reports.view.all': 'View All Reports',
  'pages.daily.reports.column.date': 'Date',
  'pages.daily.reports.column.status': 'Status',
  'pages.daily.reports.column.stats': 'Statistics',
  'pages.daily.reports.column.summary': 'Summary',
  'pages.daily.reports.column.creator': 'Creator',
  'pages.daily.reports.column.actions': 'Actions',
  'pages.daily.reports.action.view': 'View',
  'pages.daily.reports.action.edit': 'Edit',
  'pages.daily.reports.action.delete': 'Delete',
  'pages.daily.reports.search.placeholder': 'Search summary',
  'pages.daily.reports.date.start': 'Start Date',
  'pages.daily.reports.date.end': 'End Date',
  'pages.daily.reports.status.filter': 'Status',
  'pages.daily.reports.table.total': '{start}-{end} of {total}',
  'pages.daily.reports.detail.title': 'Daily Report Detail',
  'pages.daily.reports.detail.stats': 'Statistics',
  'pages.daily.reports.close': 'Close',
  'pages.daily.reports.today.button': "Today's Daily Report",

  // weekly
  'pages.weekly.reports.this.week.title': "This Week's Weekly Report",
  'pages.weekly.reports.all.title': 'All Weekly Reports',
  'pages.weekly.reports.all.subtitle':
    'View and manage all historical weekly report records',
  'pages.weekly.reports.loading': 'Loading weekly report...',
  'pages.weekly.reports.load.failed': 'Failed to load weekly report',
  'pages.weekly.reports.auto.created':
    'Weekly report auto-created successfully',
  'pages.weekly.reports.create.failed': 'Failed to create weekly report',
  'pages.weekly.reports.save.success': 'Saved successfully',
  'pages.weekly.reports.save.failed': 'Failed to save',
  'pages.weekly.reports.submit.success': 'Submitted successfully',
  'pages.weekly.reports.submit.failed': 'Failed to submit',
  'pages.weekly.reports.list.load.failed': 'Failed to load weekly reports list',
  'pages.weekly.reports.detail.load.failed':
    'Failed to load weekly report detail',
  'pages.weekly.reports.delete.success': 'Deleted successfully',
  'pages.weekly.reports.delete.failed': 'Failed to delete',
  'pages.weekly.reports.delete.confirm.title': 'Confirm Delete',
  'pages.weekly.reports.delete.confirm.content':
    'Are you sure you want to delete the weekly report for Year {year} Week {week}?',
  'pages.weekly.reports.no.data': 'No data available',
  'pages.weekly.reports.week.format': 'Year {year} Week {week}',
  'pages.weekly.reports.week.format.short': 'Week {week}',
  'pages.weekly.reports.status.draft': 'Draft',
  'pages.weekly.reports.status.submitted': 'Submitted',
  'pages.weekly.reports.status.archived': 'Archived',
  'pages.weekly.reports.stat.jobs': 'Jobs',
  'pages.weekly.reports.stat.talents': 'Talents',
  'pages.weekly.reports.stat.clients': 'Clients',
  'pages.weekly.reports.stat.projects': 'Projects',
  'pages.weekly.reports.stat.jobs.detail':
    'Updated: {updated} | Interviews: {interviews}',
  'pages.weekly.reports.stat.talents.detail':
    'Communications: {communications} | Recommended: {recommended}',
  'pages.weekly.reports.stat.clients.detail':
    'Communications: {communications} | Interviews: {interviews}',
  'pages.weekly.reports.stat.projects.detail':
    'Recommended: {recommended} | Completed: {completed}',
  'pages.weekly.reports.unit.count': 'items',
  'pages.weekly.reports.unit.person': 'people',
  'pages.weekly.reports.unit.article': 'articles',
  'pages.weekly.reports.unit.post': 'posts',
  'pages.weekly.reports.questions.stats': 'Question Master Statistics',
  'pages.weekly.reports.questions.asked': 'Questions Asked',
  'pages.weekly.reports.questions.answered': 'Questions Answered',
  'pages.weekly.reports.articles': 'Articles',
  'pages.weekly.reports.posts': 'Posts',
  'pages.weekly.reports.content': 'Weekly Report Content',
  'pages.weekly.reports.auto.summary': 'Auto-generated Weekly Summary',
  'pages.weekly.reports.autoSummary': 'Auto-generated Weekly Summary',
  'pages.weekly.reports.no.summary': 'No summary available',
  'pages.weekly.reports.noSummary': 'No summary available',
  'pages.weekly.reports.weekly.summary': 'Weekly Summary',
  'pages.weekly.reports.weeklySummary': 'Weekly Summary',
  'pages.weekly.reports.weekly.summary.placeholder':
    "Please fill in this week's work summary...",
  'pages.weekly.reports.weeklySummary.placeholder':
    "Please fill in this week's work summary...",
  'pages.weekly.reports.key.achievements': 'Key Achievements',
  'pages.weekly.reports.keyAchievements': 'Key Achievements',
  'pages.weekly.reports.key.achievements.placeholder':
    "Please fill in this week's key achievements...",
  'pages.weekly.reports.keyAchievements.placeholder':
    "Please fill in this week's key achievements...",
  'pages.weekly.reports.challenges': 'Challenges',
  'pages.weekly.reports.challenges.placeholder':
    'Please fill in the challenges encountered...',
  'pages.weekly.reports.next.week.plan': 'Next Week Plan',
  'pages.weekly.reports.nextWeekPlan': 'Next Week Plan',
  'pages.weekly.reports.next.week.plan.placeholder':
    "Please fill in next week's plan...",
  'pages.weekly.reports.nextWeekPlan.placeholder':
    "Please fill in next week's plan...",
  'pages.weekly.reports.save': 'Save',
  'pages.weekly.reports.submit': 'Submit',
  'pages.weekly.reports.view.all': 'View All Reports',
  'pages.weekly.reports.viewAll': 'View All Reports',
  'pages.weekly.reports.column.year': 'Year',
  'pages.weekly.reports.column.week': 'Week',
  'pages.weekly.reports.column.period': 'Period',
  'pages.weekly.reports.column.status': 'Status',
  'pages.weekly.reports.column.stats': 'Statistics',
  'pages.weekly.reports.column.summary': 'Summary',
  'pages.weekly.reports.column.actions': 'Actions',
  'pages.weekly.reports.action.view': 'View',
  'pages.weekly.reports.action.edit': 'Edit',
  'pages.weekly.reports.action.delete': 'Delete',
  'pages.weekly.reports.year.filter': 'Year',
  'pages.weekly.reports.status.filter': 'Status',
  'pages.weekly.reports.table.total': '{start}-{end} of {total}',
  'pages.weekly.reports.detail.title': 'Weekly Report Detail',
  'pages.weekly.reports.detail.stats': 'Statistics',
  'pages.weekly.reports.close': 'Close',
  'pages.weekly.reports.this.week.button': "This Week's Weekly Report",

  // monthly
  'pages.monthly.reports.this.month.title': "This Month's Monthly Report",
  'pages.monthly.reports.all.title': 'All Monthly Reports',
  'pages.monthly.reports.all.subtitle':
    'View and manage all historical monthly report records',
  'pages.monthly.reports.loading': 'Loading monthly report...',
  'pages.monthly.reports.auto.created':
    'Monthly report auto-created successfully',
  'pages.monthly.reports.create.failed': 'Failed to create monthly report',
  'pages.monthly.reports.save.success': 'Saved successfully',
  'pages.monthly.reports.submit.success': 'Submitted successfully',
  'pages.monthly.reports.submit.failed': 'Failed to submit',
  'pages.monthly.reports.list.load.failed':
    'Failed to load monthly reports list',
  'pages.monthly.reports.delete.confirm.title': 'Confirm Delete',
  'pages.monthly.reports.delete.confirm.content':
    'Are you sure you want to delete the monthly report for Year {year} Month {month}?',
  'pages.monthly.reports.no.data': 'No data available',
  'pages.monthly.reports.month.format': 'Year {year} Month {month}',
  'pages.monthly.reports.month.format.short': 'Month {month}',
  'pages.monthly.reports.status.archived': 'Archived',
  'pages.monthly.reports.stat.jobs': 'Jobs',
  'pages.monthly.reports.stat.talents': 'Talents',
  'pages.monthly.reports.stat.clients': 'Clients',
  'pages.monthly.reports.stat.projects': 'Projects',
  'pages.monthly.reports.stat.jobs.detail':
    'Updated: {updated} | Interviews: {interviews}',
  'pages.monthly.reports.stat.talents.detail':
    'Communications: {communications} | Recommended: {recommended}',
  'pages.monthly.reports.stat.clients.detail':
    'Communications: {communications} | Interviews: {interviews}',
  'pages.monthly.reports.stat.projects.detail':
    'Completed: {completed} | Successful: {successful}',
  'pages.monthly.reports.unit.count': 'items',
  'pages.monthly.reports.unit.person': 'people',
  'pages.monthly.reports.revenue': 'Monthly Revenue',
  'pages.monthly.reports.projects.completed': 'Completed Projects',
  'pages.monthly.reports.projects.successful': 'Successful Projects',
  'pages.monthly.reports.content': 'Monthly Report Content',
  'pages.monthly.reports.auto.summary': 'Auto-generated Monthly Summary',
  'pages.monthly.reports.no.summary': 'No summary available',
  'pages.monthly.reports.monthly.summary': 'Monthly Summary',
  'pages.monthly.reports.monthly.summary.placeholder':
    "Please fill in this month's work summary...",
  'pages.monthly.reports.key.achievements': 'Key Achievements',
  'pages.monthly.reports.key.achievements.placeholder':
    "Please fill in this month's key achievements...",
  'pages.monthly.reports.important.projects': 'Important Projects',
  'pages.monthly.reports.important.projects.placeholder':
    "Please fill in this month's important projects...",
  'pages.monthly.reports.important.clients': 'Important Clients',
  'pages.monthly.reports.important.clients.placeholder':
    "Please fill in this month's important clients...",
  'pages.monthly.reports.challenges': 'Challenges',
  'pages.monthly.reports.challenges.placeholder':
    'Please fill in the challenges encountered...',
  'pages.monthly.reports.next.month.plan': 'Next Month Plan',
  'pages.monthly.reports.next.month.plan.placeholder':
    "Please fill in next month's plan...",
  'pages.monthly.reports.goal.completion': 'Goal Completion',
  'pages.monthly.reports.save': 'Save',
  'pages.monthly.reports.submit': 'Submit',
  'pages.monthly.reports.view.all': 'View All Reports',
  'pages.monthly.reports.column.year': 'Year',
  'pages.monthly.reports.column.period': 'Period',
  'pages.monthly.reports.column.stats': 'Statistics',
  'pages.monthly.reports.column.revenue': 'Revenue',
  'pages.monthly.reports.column.summary': 'Summary',
  'pages.monthly.reports.action.view': 'View',
  'pages.monthly.reports.action.edit': 'Edit',
  'pages.monthly.reports.action.delete': 'Delete',
  'pages.monthly.reports.year.filter': 'Year',
  'pages.monthly.reports.month.filter': 'Month',
  'pages.monthly.reports.status.filter': 'Status',
  'pages.monthly.reports.table.total': '{start}-{end} of {total}',
  'pages.monthly.reports.detail.stats': 'Statistics',
  'pages.monthly.reports.close': 'Close',
  'pages.monthly.reports.this.month.button': "This Month's Monthly Report",

  // yearly
  'pages.yearly.reports.this.year.title': "This Year's Yearly Report",
  'pages.yearly.reports.all.title': 'All Yearly Reports',
  'pages.yearly.reports.all.subtitle':
    'View and manage all historical yearly report records',
  'pages.yearly.reports.loading': 'Loading yearly report...',
  'pages.yearly.reports.load.failed': 'Failed to load yearly report',
  'pages.yearly.reports.auto.created':
    'Yearly report auto-created successfully',
  'pages.yearly.reports.create.failed': 'Failed to create yearly report',
  'pages.yearly.reports.save.success': 'Saved successfully',
  'pages.yearly.reports.save.failed': 'Failed to save',
  'pages.yearly.reports.submit.success': 'Submitted successfully',
  'pages.yearly.reports.submit.failed': 'Failed to submit',
  'pages.yearly.reports.list.load.failed': 'Failed to load yearly reports list',
  'pages.yearly.reports.detail.load.failed':
    'Failed to load yearly report detail',
  'pages.yearly.reports.delete.success': 'Deleted successfully',
  'pages.yearly.reports.delete.failed': 'Failed to delete',
  'pages.yearly.reports.delete.confirm.title': 'Confirm Delete',
  'pages.yearly.reports.delete.confirm.content':
    'Are you sure you want to delete the yearly report for Year {year}?',
  'pages.yearly.reports.no.data': 'No data available',
  'pages.yearly.reports.year.format': 'Year {year}',
  'pages.yearly.reports.status.draft': 'Draft',
  'pages.yearly.reports.status.submitted': 'Submitted',
  'pages.yearly.reports.status.archived': 'Archived',
  'pages.yearly.reports.stat.jobs': 'Jobs',
  'pages.yearly.reports.stat.talents': 'Talents',
  'pages.yearly.reports.stat.clients': 'Clients',
  'pages.yearly.reports.stat.projects': 'Projects',
  'pages.yearly.reports.stat.jobs.detail':
    'Updated: {updated} | Interviews: {interviews}',
  'pages.yearly.reports.stat.talents.detail':
    'Communications: {communications} | Recommended: {recommended}',
  'pages.yearly.reports.stat.clients.detail':
    'Communications: {communications} | Interviews: {interviews}',
  'pages.yearly.reports.stat.projects.detail':
    'Completed: {completed} | Successful: {successful}',
  'pages.yearly.reports.unit.count': 'items',
  'pages.yearly.reports.unit.person': 'people',
  'pages.yearly.reports.revenue': 'Yearly Revenue',
  'pages.yearly.reports.projects.completed': 'Completed Projects',
  'pages.yearly.reports.projects.successful': 'Successful Projects',
  'pages.yearly.reports.content': 'Yearly Report Content',
  'pages.yearly.reports.auto.summary': 'Auto-generated Yearly Summary',
  'pages.yearly.reports.no.summary': 'No summary available',
  'pages.yearly.reports.yearly.summary': 'Yearly Summary',
  'pages.yearly.reports.yearly.summary.placeholder':
    "Please fill in this year's work summary...",
  'pages.yearly.reports.key.achievements': 'Key Achievements',
  'pages.yearly.reports.key.achievements.placeholder':
    "Please fill in this year's key achievements...",
  'pages.yearly.reports.important.projects': 'Important Projects',
  'pages.yearly.reports.important.projects.placeholder':
    "Please fill in this year's important projects...",
  'pages.yearly.reports.important.clients': 'Important Clients',
  'pages.yearly.reports.important.clients.placeholder':
    "Please fill in this year's important clients...",
  'pages.yearly.reports.milestones': 'Milestones',
  'pages.yearly.reports.milestones.placeholder':
    "Please fill in this year's milestones...",
  'pages.yearly.reports.challenges': 'Challenges',
  'pages.yearly.reports.challenges.placeholder':
    'Please fill in the challenges encountered...',
  'pages.yearly.reports.solutions': 'Solutions',
  'pages.yearly.reports.solutions.placeholder':
    'Please fill in the solutions...',
  'pages.yearly.reports.growth': 'Growth',
  'pages.yearly.reports.growth.placeholder': 'Please fill in your growth...',
  'pages.yearly.reports.next.year.plan': 'Next Year Plan',
  'pages.yearly.reports.next.year.plan.placeholder':
    "Please fill in next year's plan...",
  'pages.yearly.reports.goal.completion': 'Goal Completion',
  'pages.yearly.reports.save': 'Save',
  'pages.yearly.reports.submit': 'Submit',
  'pages.yearly.reports.view.all': 'View All Reports',
  'pages.yearly.reports.column.year': 'Year',
  'pages.yearly.reports.column.period': 'Period',
  'pages.yearly.reports.column.status': 'Status',
  'pages.yearly.reports.column.stats': 'Statistics',
  'pages.yearly.reports.column.revenue': 'Revenue',
  'pages.yearly.reports.column.summary': 'Summary',
  'pages.yearly.reports.column.actions': 'Actions',
  'pages.yearly.reports.action.view': 'View',
  'pages.yearly.reports.action.edit': 'Edit',
  'pages.yearly.reports.action.delete': 'Delete',
  'pages.yearly.reports.year.filter': 'Year',
  'pages.yearly.reports.status.filter': 'Status',
  'pages.yearly.reports.table.total': '{start}-{end} of {total}',
  'pages.yearly.reports.detail.title': 'Yearly Report Detail',
  'pages.yearly.reports.detail.stats': 'Statistics',
  'pages.yearly.reports.close': 'Close',
  'pages.yearly.reports.this.year.button': "This Year's Yearly Report",

  // data
  'pages.data.dict.title': 'Data Dictionary',
  'pages.data.dict.subtitle':
    'Maintain reusable categories and options for forms.',
  'pages.data.dict.refresh': 'Refresh',
  'pages.data.dict.add.category': 'Add Category',
  'pages.data.dict.add.item': 'Add Option',
  'pages.data.dict.edit.category.title': 'Edit Category',
  'pages.data.dict.add.category.title': 'Create Category',
  'pages.data.dict.edit.item.title': 'Edit Option',
  'pages.data.dict.add.item.title': 'Create Option',
  'pages.data.dict.form.name': 'Name',
  'pages.data.dict.form.name.required': 'Please enter the name',
  'pages.data.dict.form.code': 'Code',
  'pages.data.dict.form.code.required': 'Please enter the code',
  'pages.data.dict.form.description': 'Description',
  'pages.data.dict.form.parent': 'Parent UUID',
  'pages.data.dict.form.parent.placeholder':
    'Fill parent category UUID (optional)',
  'pages.data.dict.form.sort': 'Sort',
  'pages.data.dict.form.active': 'Active',
  'pages.data.dict.item.form.category': 'Category',
  'pages.data.dict.item.form.parent': 'Parent Option',
  'pages.data.dict.item.form.parent.placeholder':
    'Select parent option (optional)',
  'pages.data.dict.item.form.parent.tooltip':
    'Select a parent option to create a hierarchical structure',
  'pages.data.dict.item.form.label': 'Label',
  'pages.data.dict.item.form.label.required': 'Please enter the label',
  'pages.data.dict.item.form.value': 'Value',
  'pages.data.dict.item.form.value.required': 'Please enter the value',
  'pages.data.dict.item.form.description': 'Description',
  'pages.data.dict.item.form.sort': 'Sort',
  'pages.data.dict.item.form.default': 'Default',
  'pages.data.dict.item.form.active': 'Active',
  'pages.data.dict.column.name': 'Name',
  'pages.data.dict.column.code': 'Code',
  'pages.data.dict.column.sort': 'Sort',
  'pages.data.dict.column.count': 'Options',
  'pages.data.dict.column.status': 'Status',
  'pages.data.dict.column.actions': 'Actions',
  'pages.data.dict.item.column.label': 'Label',
  'pages.data.dict.item.column.value': 'Value',
  'pages.data.dict.item.column.description': 'Description',
  'pages.data.dict.item.column.sort': 'Sort',
  'pages.data.dict.item.column.default': 'Default',
  'pages.data.dict.item.column.status': 'Status',
  'pages.data.dict.item.column.actions': 'Actions',
  'pages.data.dict.status.active': 'Enabled',
  'pages.data.dict.status.inactive': 'Disabled',
  'pages.data.dict.action.edit': 'Edit',
  'pages.data.dict.action.add.child': 'Add Child Option',
  'pages.data.dict.action.delete': 'Delete',
  'pages.data.dict.confirm': 'Confirm',
  'pages.data.dict.cancel': 'Cancel',
  'pages.data.dict.delete.category.confirm':
    'Delete this category? Options must be removed first.',
  'pages.data.dict.delete.item.confirm': 'Delete this option?',
  'pages.data.dict.save.success': 'Saved successfully',
  'pages.data.dict.save.failed': 'Save failed, please retry',
  'pages.data.dict.delete.success': 'Deleted successfully',
  'pages.data.dict.delete.failed': 'Delete failed, please retry',
  'pages.data.dict.load.categories.failed': 'Failed to load categories',
  'pages.data.dict.load.items.failed': 'Failed to load options',
  'pages.data.dict.categories': 'Categories',
  'pages.data.dict.items.title': 'Options - {category}',
  'pages.data.dict.select.category.first': 'Please select a category first',
  'pages.data.dict.search.placeholder': 'Search by name or code',
  'pages.data.dict.flag.yes': 'Yes',
  'pages.data.dict.flag.no': 'No',

  // personal
  'pages.personal.settings.title': 'Personal Settings',
  'pages.personal.settings.subtitle':
    'Manage headhunter profile information, including avatar, name, position, contact details, etc.',
  'pages.personal.settings.save.success': 'Settings saved successfully',
  'pages.personal.settings.save.failed':
    'Failed to save, please try again later',
  'pages.personal.settings.avatar.updated': 'Avatar updated',
  'pages.personal.settings.avatar.upload.failed':
    'Failed to upload avatar, please try again later',
  'pages.personal.settings.section.personal': 'Personal Information',
  'pages.personal.settings.section.system': 'System Preferences',
  'pages.personal.settings.section.notifications': 'Notification Settings',
  'pages.personal.settings.section.security': 'Security & Privacy',
  'pages.personal.settings.change.avatar': 'Change Avatar',
  'pages.personal.settings.avatar.tip':
    'Recommended 256×256px, supports JPG/PNG',
  'pages.personal.settings.name': 'Name',
  'pages.personal.settings.name.required': 'Please enter your name',
  'pages.personal.settings.name.placeholder': 'Enter your full name',
  'pages.personal.settings.position': 'Title',
  'pages.personal.settings.position.required': 'Please enter your title',
  'pages.personal.settings.position.placeholder': 'e.g. Senior Headhunter',
  'pages.personal.settings.email': 'Email',
  'pages.personal.settings.email.required': 'Please enter an email',
  'pages.personal.settings.email.invalid': 'Please enter a valid email',
  'pages.personal.settings.email.placeholder': 'name@company.com',
  'pages.personal.settings.phone': 'Phone',
  'pages.personal.settings.phone.required': 'Please enter a phone number',
  'pages.personal.settings.phone.placeholder': 'Enter phone number',
  'pages.personal.settings.company': 'Company',
  'pages.personal.settings.company.required': 'Please enter a company name',
  'pages.personal.settings.company.placeholder': 'Enter company name',
  'pages.personal.settings.signature': 'Personal Signature',
  'pages.personal.settings.signature.placeholder':
    'Introduce yourself or leave a signature for reports...',
  'pages.personal.settings.language': 'Language',
  'pages.personal.settings.language.required': 'Please select a language',
  'pages.personal.settings.language.placeholder': 'Select interface language',
  'pages.personal.settings.language.zh': 'Simplified Chinese',
  'pages.personal.settings.language.en': 'English',
  'pages.personal.settings.timezone': 'Timezone',
  'pages.personal.settings.timezone.required': 'Please select a timezone',
  'pages.personal.settings.timezone.placeholder': 'Select timezone',
  'pages.personal.settings.data.retention': 'Data Retention',
  'pages.personal.settings.data.retention.required':
    'Please set data retention days',
  'pages.personal.settings.data.retention.placeholder': 'Enter number of days',
  'pages.personal.settings.days': 'days',
  'pages.personal.settings.minutes': 'minutes',
  'pages.personal.settings.auto.backup': 'Automatic Backup',
  'pages.personal.settings.email.notifications': 'Email Notifications',
  'pages.personal.settings.sms.notifications': 'SMS Notifications',
  'pages.personal.settings.weekly.report': 'Weekly Report Reminder',
  'pages.personal.settings.notification.time': 'Reminder Time',
  'pages.personal.settings.notification.time.placeholder':
    'Select reminder time',
  'pages.personal.settings.report.day': 'Report Day',
  'pages.personal.settings.report.day.placeholder': 'Select a day',
  'pages.personal.settings.monday': 'Monday',
  'pages.personal.settings.tuesday': 'Tuesday',
  'pages.personal.settings.wednesday': 'Wednesday',
  'pages.personal.settings.thursday': 'Thursday',
  'pages.personal.settings.friday': 'Friday',
  'pages.personal.settings.two.factor': 'Two-factor Authentication',
  'pages.personal.settings.login.alerts': 'Login Alerts',
  'pages.personal.settings.session.timeout': 'Session Timeout',
  'pages.personal.settings.session.timeout.placeholder':
    'Select timeout duration',
  'pages.personal.settings.password.expiry': 'Password Expiry',
  'pages.personal.settings.password.expiry.placeholder': 'Select expiry policy',
  'pages.personal.settings.never.expire': 'Never expire',
  'pages.personal.settings.change.password': 'Change Password',
  'pages.personal.settings.delete.account': 'Delete Account',
  'pages.personal.settings.save.button': 'Save Settings',

  // message
  'pages.message.title': 'Message Center',
  'pages.message.unread.tip': 'You have {count} unread messages',
  'pages.message.no.unread': 'No unread messages',
  'pages.message.mark.all': 'Mark All as Read',
  'pages.message.tab.all': 'All',
  'pages.message.tab.job': 'Jobs',
  'pages.message.tab.talent': 'Talents',
  'pages.message.tab.client': 'Clients',
  'pages.message.tab.project': 'Projects',
  'pages.message.tab.system': 'System',
  'pages.message.tab.reminder': 'Reminders',
  'pages.message.load.failed': 'Failed to load messages',
  'pages.message.mark.failed': 'Operation failed',
  'pages.message.mark.all.success': 'All messages marked as read',
  'pages.message.delete.success': 'Message deleted',
  'pages.message.delete.failed': 'Failed to delete message',
  'pages.message.empty': 'No messages',
  'pages.message.mark.read': 'Mark as Read',
  'pages.message.delete': 'Delete',
  'pages.message.total.text': 'Showing {start}-{end} of {total} messages',
  'pages.message.category.info': 'Info',
  'pages.message.category.warning': 'Warning',
  'pages.message.category.error': 'Error',
  'pages.message.category.success': 'Success',
  'pages.message.priority.urgent': 'Urgent',
  'pages.message.priority.high': 'High',
  'pages.message.priority.normal': 'Normal',
  'pages.message.priority.low': 'Low',
  'pages.message.priority.badge': 'Urgent',
  'pages.message.type.job': 'Job',
  'pages.message.type.talent': 'Talent',
  'pages.message.type.client': 'Client',
  'pages.message.type.project': 'Project',
  'pages.message.type.system': 'System',
  'pages.message.type.reminder': 'Reminder',

  // report
  'pages.report.templates.title': 'Recommendation Report Templates',
  'pages.report.templates.subtitle':
    'Create and manage reusable recommendation report templates.',
  'pages.report.templates.load.failed': 'Failed to load templates',
  'pages.report.templates.attachment.load.failed': 'Failed to load attachments',
  'pages.report.templates.update.success': 'Template updated successfully',
  'pages.report.templates.create.success': 'Template created successfully',
  'pages.report.templates.save.failed': 'Failed to save template',
  'pages.report.templates.delete.success': 'Template deleted',
  'pages.report.templates.delete.failed': 'Failed to delete template',
  'pages.report.templates.duplicate.success': 'Template duplicated',
  'pages.report.templates.duplicate.failed': 'Failed to duplicate template',
  'pages.report.templates.set.default.success': 'Default template updated',
  'pages.report.templates.set.default.failed': 'Failed to set default template',
  'pages.report.templates.attachment.delete.success': 'Attachment deleted',
  'pages.report.templates.attachment.delete.failed':
    'Failed to delete attachment',
  'pages.report.templates.attachment.upload.success': 'Attachment uploaded',
  'pages.report.templates.attachment.upload.failed':
    'Failed to upload attachment',
  'pages.report.templates.file.too.large': 'File size must be less than 100MB',
  'pages.report.templates.default': 'Default',
  'pages.report.templates.has.description': '(with description)',
  'pages.report.templates.no.attachments': 'No attachments',
  'pages.report.templates.download': 'Download',
  'pages.report.templates.download.all': 'Download All',
  'pages.report.templates.attachment.count': '{count} attachments',
  'pages.report.templates.column.name': 'Template Name',
  'pages.report.templates.column.attachments': 'Attachments',
  'pages.report.templates.column.created': 'Created At',
  'pages.report.templates.column.actions': 'Actions',
  'pages.report.templates.action.edit': 'Edit',
  'pages.report.templates.action.duplicate': 'Duplicate',
  'pages.report.templates.action.set.default': 'Set as Default',
  'pages.report.templates.action.delete': 'Delete',
  'pages.report.templates.delete.confirm':
    'Are you sure you want to delete this template?',
  'pages.report.templates.confirm': 'Confirm',
  'pages.report.templates.cancel': 'Cancel',
  'pages.report.templates.search.placeholder': 'Search template name',
  'pages.report.templates.create': 'New Template',
  'pages.report.templates.table.total': '{start}-{end} of {total}',
  'pages.report.templates.modal.edit': 'Edit Template',
  'pages.report.templates.modal.create': 'Create Template',
  'pages.report.templates.modal.save': 'Save',
  'pages.report.templates.field.name': 'Template Name',
  'pages.report.templates.field.name.required': 'Please enter a template name',
  'pages.report.templates.field.name.placeholder': 'Enter template name',
  'pages.report.templates.field.description': 'Description',
  'pages.report.templates.field.description.placeholder':
    'Describe the template',
  'pages.report.templates.existing.attachments': 'Existing Attachments',
  'pages.report.templates.view': 'Preview',
  'pages.report.templates.attachment.delete.confirm': 'Delete this attachment?',
  'pages.report.templates.delete': 'Delete',
  'pages.report.templates.upload.new': 'Upload New Attachment',
  'pages.report.templates.upload.file': 'Template File',
  'pages.report.templates.upload.hint': 'Click or drag files to upload',
  'pages.report.templates.upload.desc':
    'Supports PDF, DOC, DOCX, TXT, HTML up to 100MB.',
  'pages.report.templates.field.default': 'Default Template',
  'pages.report.templates.upload.mode': 'Upload Mode',
  'pages.report.templates.upload.mode.file': 'Upload File',
  'pages.report.templates.upload.mode.link': 'Use Link',
  'pages.report.templates.link.url': 'Template Link',
  'pages.report.templates.link.url.placeholder': 'Enter template file URL',
  'pages.report.templates.link.url.hint':
    'Enter a valid URL to download the template file',
  'pages.report.templates.download.link': 'Download Template',
  'pages.report.templates.download.link.loading': 'Downloading...',
  'pages.report.templates.download.link.success':
    'Template downloaded successfully, please edit and upload',
  'pages.report.templates.download.link.failed':
    'Failed to download template from link',
  'pages.report.templates.link.invalid': 'Please enter a valid URL',
  'pages.report.templates.link.hint':
    'Enter a template file URL, download it, edit it, and then upload it',
  'pages.report.templates.download.template': 'Download Template from Link',
  'pages.report.templates.download.template.desc':
    'Click the button to download the template file, edit it, and then upload',

  // search
  'pages.search.title': 'Search',
  'pages.search.subtitle':
    'Search questions, articles, posts, topics and users',
  'pages.search.placeholder': 'Enter keywords to search...',
  'pages.search.please.enter.keyword': 'Please enter search keywords',
  'pages.search.search.failed': 'Search failed, please try again later',
  'pages.search.no.results': 'No search results',
  'pages.search.filter.all': 'All',
  'pages.search.filter.questions': 'Questions',
  'pages.search.filter.articles': 'Articles',
  'pages.search.filter.posts': 'Posts',
  'pages.search.filter.topics': 'Topics',
  'pages.search.sort.relevance': 'Relevance',
  'pages.search.sort.latest': 'Latest',
  'pages.search.sort.hot': 'Hot',
  'pages.search.tab.all': 'All',
  'pages.search.tab.questions': 'Questions',
  'pages.search.tab.articles': 'Articles',
  'pages.search.tab.posts': 'Posts',
  'pages.search.tab.topics': 'Topics',
  'pages.search.uncategorized': 'Uncategorized',
  'pages.search.answers': 'Answers',
  'pages.search.paid': 'Paid',
  'pages.search.images': 'images',
  'pages.search.followers': 'Followers',
  'pages.search.questions': 'Questions',
  'pages.search.articles': 'Articles',
  'pages.search.official': 'Official',

  // notifications
  'pages.notification.title': 'Notifications',
  'pages.notification.load.failed': 'Failed to load notifications',
  'pages.notification.unread.count': '{count} unread notifications',
  'pages.notification.no.unread': 'No unread notifications',
  'pages.notification.mark.all.read': 'Mark all as read',
  'pages.notification.mark.all.success': 'All marked as read',
  'pages.notification.operation.failed': 'Operation failed',
  'pages.notification.delete': 'Delete',
  'pages.notification.delete.success': 'Deleted successfully',
  'pages.notification.delete.failed': 'Failed to delete',
  'pages.notification.mark.read': 'Mark as read',
  'pages.notification.no.notifications': 'No notifications',

  // topics
  'pages.topics.title': 'Topics',
  'pages.topics.subtitle': 'Explore and follow topics you are interested in',
  'pages.topics.search.placeholder': 'Search topics...',
  'pages.topics.tab.all': 'All',
  'pages.topics.tab.hot': 'Hot',
  'pages.topics.tab.recommended': 'Recommended',
  'pages.topics.follow': 'Follow',
  'pages.topics.following': 'Following',
  'pages.topics.followers': 'Followers',
  'pages.topics.questions': 'Questions',
  'pages.topics.articles': 'Articles',
  'pages.topics.official': 'Official',
  'pages.topics.no.topics': 'No topics found',
  'pages.topics.total': 'Total {total} items',
  'pages.topics.load.failed': 'Failed to load topics',
  'pages.topics.follow.success': 'Followed successfully',
  'pages.topics.unfollow.success': 'Unfollowed successfully',
  'pages.topics.operation.failed': 'Operation failed',

  // topic-detail
  'pages.topicDetail.load.failed': 'Failed to load topic',
  'pages.topicDetail.loading': 'Loading topic...',
  'pages.topicDetail.not.found': 'Topic not found',
  'pages.topicDetail.back': 'Back',
  'pages.topicDetail.followers': 'Followers',
  'pages.topicDetail.questions': 'Questions',
  'pages.topicDetail.answers': 'Answers',
  'pages.topicDetail.articles': 'Articles',
  'pages.topicDetail.posts': 'Posts',
  'pages.topicDetail.following': 'Following',
  'pages.topicDetail.follow.topic': 'Follow Topic',
  'pages.topicDetail.no.questions': 'No questions yet',
  'pages.topicDetail.no.articles': 'No articles yet',
  'pages.topicDetail.no.posts': 'No posts yet',
  'pages.topicDetail.follow.success': 'Followed successfully',
  'pages.topicDetail.unfollow.success': 'Unfollowed successfully',
  'pages.topicDetail.operation.failed': 'Operation failed',

  // user-profile
  'pages.userProfile.user': 'User',
  'pages.userProfile.bio.placeholder': 'No bio yet',
  'pages.userProfile.location.placeholder': 'Unknown location',
  'pages.userProfile.joined.at': 'Joined',
  'pages.userProfile.follow': 'Follow',
  'pages.userProfile.following': 'Following',
  'pages.userProfile.follow.success': 'Followed successfully',
  'pages.userProfile.unfollow.success': 'Unfollowed successfully',
  'pages.userProfile.operation.failed': 'Operation failed',
  'pages.userProfile.questions': 'Questions',
  'pages.userProfile.articles': 'Articles',
  'pages.userProfile.posts': 'Posts',
  'pages.userProfile.followers': 'Followers',
  'pages.userProfile.no.questions': 'No questions yet',
  'pages.userProfile.no.articles': 'No articles yet',
  'pages.userProfile.no.posts': 'No posts yet',

  // feed
  'pages.feed.load.failed': 'Failed to load feed',
  'pages.feed.anonymous.user': 'Anonymous User',
  'pages.feed.unknown.user': 'Unknown User',
  'pages.feed.answers': 'Answers',
  'pages.feed.answered.question': 'Answered question',
  'pages.feed.best.answer': 'Best Answer',
  'pages.feed.article': 'Article',
  'pages.feed.paid': 'Paid',
  'pages.feed.post': 'Post',
  'pages.feed.image': 'Image',
  'pages.feed.share': 'Share',
  'pages.feed.title': 'Feed',
  'pages.feed.subtitle': 'Stay updated with the latest content',
  'pages.feed.post.modal.coming.soon': 'Coming soon!',
  'pages.feed.publish.post': 'Publish Post',
  'pages.feed.recommended': 'Recommended',
  'pages.feed.latest': 'Latest',
  'pages.feed.hot': 'Hot',
  'pages.feed.following': 'Following',
  'pages.feed.no.content': 'No content available',
  'pages.feed.no.more': 'No more content',

  // talents
  'pages.talents.subtitle':
    'Manage all talent information, support resume parsing, tag management, and private pool management.',
  'pages.talents.search.placeholder':
    'Search by name, company, position, skills...',
  'pages.talents.search.keywordHint': 'Separate multiple keywords with spaces',
  'pages.talents.filter.status': 'Filter by status',
  'pages.talents.advanced.search': 'Advanced search',
  'pages.talents.add.talent': 'Add Talent',
  'pages.talents.edit.talent': 'Edit Talent',
  'pages.talents.load.failed': 'Failed to load talents, please retry later.',
  'pages.talents.create.success': 'Talent created successfully',
  'pages.talents.update.success': 'Talent updated successfully',
  'pages.talents.save.failed': 'Failed to save talent, please retry later.',
  'pages.talents.no.data': 'No talent records',
  'pages.talents.items': 'talents',
  'pages.talents.total.results': 'Total: {total} results',

  // talents - status
  'pages.talents.status.all': 'All',
  'pages.talents.status.active': 'Active',
  'pages.talents.status.inactive': 'Inactive',
  'pages.talents.status.placed': 'Placed',
  'pages.talents.status.blacklisted': 'Blacklisted',

  // talents - columns
  'pages.talents.column.name': 'Name',
  'pages.talents.column.company': 'Company',
  'pages.talents.column.position': 'Position',
  'pages.talents.column.location': 'Location',
  'pages.talents.column.salary': 'Salary',
  'pages.talents.column.age': 'Age',
  'pages.talents.column.phone': 'Phone',
  'pages.talents.column.tags': 'Tags',
  'pages.talents.column.status': 'Status',
  'pages.talents.column.last.contact': 'Last Contact',
  'pages.talents.column.latest.remark': 'Latest Remark',
  'pages.talents.column.actions': 'Actions',
  'pages.talents.column.owner': 'Owner',

  // talents - actions
  'pages.talents.action.view': 'View',
  'pages.talents.action.edit': 'Edit',
  'pages.talents.action.delete': 'Delete',
  'pages.talents.action.add.to.collection': 'Add to Collection',
  'pages.talents.action.remove.from.collection': 'Remove from Collection',
  'pages.talents.action.add.to.private': 'Add to Private Pool',
  'pages.talents.action.remove.from.private': 'Remove from Private Pool',

  // talents - fields
  'pages.talents.field.name': 'Name',
  'pages.talents.field.name.required': 'Please enter name',
  'pages.talents.field.name.placeholder': 'Enter name',
  'pages.talents.field.gender': 'Gender',
  'pages.talents.field.gender.placeholder': 'Select gender',
  'pages.talents.field.gender.male': 'Male',
  'pages.talents.field.gender.female': 'Female',
  'pages.talents.field.age': 'Age',
  'pages.talents.field.age.placeholder': 'Enter age',
  'pages.talents.field.phone': 'Phone',
  'pages.talents.field.phone.placeholder': 'Enter phone',
  'pages.talents.field.email': 'Email',
  'pages.talents.field.email.placeholder': 'Enter email',
  'pages.talents.field.current.company': 'Current Company',
  'pages.talents.field.current.company.placeholder': 'Enter current company',
  'pages.talents.field.current.position': 'Current Position',
  'pages.talents.field.current.position.placeholder': 'Enter current position',
  'pages.talents.field.current.salary': 'Current Salary',
  'pages.talents.field.current.salary.placeholder': 'Enter current salary',
  'pages.talents.field.expected.salary': 'Expected Salary',
  'pages.talents.field.expected.salary.placeholder': 'Enter expected salary',
  'pages.talents.field.work.experience': 'Work Experience',
  'pages.talents.field.work.experience.placeholder': 'Enter work experience',
  'pages.talents.field.location': 'Location',
  'pages.talents.field.location.placeholder': 'Enter location',
  'pages.talents.field.status': 'Status',
  'pages.talents.field.status.placeholder': 'Select status',
  'pages.talents.field.tags': 'Tags',
  'pages.talents.field.tags.placeholder': 'Enter tags',
  'pages.talents.field.skills': 'Skills',
  'pages.talents.field.skills.placeholder': 'Enter skills',
  'pages.talents.field.notes': 'Notes',
  'pages.talents.field.notes.placeholder': 'Enter notes',
  'pages.talents.field.birthdate': 'Birth Date',
  'pages.talents.field.education': 'Education',
  'pages.talents.field.education.placeholder': 'Select education',
  'pages.talents.field.wechat': 'WeChat',
  'pages.talents.field.source': 'Source',
  'pages.talents.field.language': 'Language',
  'pages.talents.field.hukou': 'Hukou',
  'pages.talents.field.id': 'ID',
  'pages.talents.field.id.placeholder': 'Enter ID',

  // talents - education options
  'pages.talents.education.doctor': 'Doctorate',
  'pages.talents.education.master': 'Master',
  'pages.talents.education.bachelor': 'Bachelor',
  'pages.talents.education.college': 'College',
  'pages.talents.education.senior': 'High School',

  // talents - import
  'pages.talents.import.title': 'Import Resume',
  'pages.talents.import.file.label': 'Resume File',
  'pages.talents.import.file.placeholder': 'Click to upload resume',
  'pages.talents.import.file.required': 'Please select a resume file',
  'pages.talents.import.file.support':
    'Supports PDF, DOC, DOCX formats, max 20MB',
  'pages.talents.import.success': 'Import successful',
  'pages.talents.import.failed': 'Import failed',
  'pages.talents.import.parse.info':
    'Resume parsed successfully, filled into form',

  // talents - modal
  'pages.talents.modal.add.title': 'Add Talent',
  'pages.talents.modal.edit.title': 'Edit Talent',
  'pages.talents.modal.cancel': 'Cancel',
  'pages.talents.modal.save': 'Save',

  // talents - advanced search
  'pages.talents.advanced.title': 'Advanced Search',
  'pages.talents.advanced.reset': 'Reset',
  'pages.talents.advanced.cancel': 'Cancel',
  'pages.talents.advanced.submit': 'Apply',
  'pages.talents.advanced.search.title': 'Advanced Search',

  // talents - delete
  'pages.talents.delete.confirm.title': 'Confirm Delete',
  'pages.talents.delete.confirm.content':
    'Are you sure you want to delete talent "{name}"? This action cannot be undone.',
  'pages.talents.delete.success': 'Talent deleted successfully',
  'pages.talents.delete.failed': 'Failed to delete talent',
  'pages.talents.delete.no.permission':
    'You do not have permission to delete this talent. Only public pool talents or your own private talents can be deleted.',
  'pages.talents.select.to.delete': 'Please select talents to delete',
  'pages.talents.batch.delete': 'Batch Delete ({count})',
  'pages.talents.batch.delete.confirm.title': 'Confirm Batch Delete',
  'pages.talents.batch.delete.confirm.content':
    'Are you sure you want to delete {count} selected talents? This action cannot be undone.',
  'pages.talents.batch.delete.success': 'Successfully deleted {count} talents',
  'pages.talents.batch.delete.failed': 'Batch delete failed',
  'pages.talents.batch.delete.no.permission':
    'No deletable talents in selection. Only public pool talents or your own private talents can be deleted.',
  'pages.talents.batch.delete.partial.permission':
    '{count} talents cannot be deleted due to permission restrictions and will be skipped.',

  // talents - collection
  'pages.talents.collection.add': 'Add to Collection',
  'pages.talents.collection.add.success': 'Added to collection successfully',
  'pages.talents.collection.add.failed': 'Failed to add to collection',
  'pages.talents.collection.remove.success':
    'Removed from collection successfully',
  'pages.talents.collection.remove.failed': 'Failed to remove from collection',
  'pages.talents.collection.select': 'Select Collection',
  'pages.talents.collection.create': 'Create New Collection',
  'pages.talents.collection.edit': 'Edit Collection',
  'pages.talents.collection.name': 'Collection Name',
  'pages.talents.collection.name.required': 'Please enter collection name',
  'pages.talents.collection.name.placeholder': 'Enter collection name',
  'pages.talents.collection.description': 'Collection Description',
  'pages.talents.collection.description.placeholder':
    'Enter collection description',
  'pages.talents.collection.talent.count': '{count} talents',
  'pages.talents.collection.no.collections':
    'No collections yet, please create one first',
  'pages.talents.collection.load.failed': 'Failed to load collections',
  'pages.talents.collection.create.success': 'Collection created successfully',
  'pages.talents.collection.create.failed': 'Failed to create collection',
  'pages.talents.collection.update.success': 'Collection updated successfully',
  'pages.talents.collection.update.failed': 'Failed to update collection',
  'pages.talents.collection.delete.success': 'Collection deleted successfully',
  'pages.talents.collection.delete.failed': 'Failed to delete collection',
  'pages.talents.collection.delete.confirm':
    'Are you sure you want to delete collection "{name}"?',

  // talents - view
  'pages.talents.view.table': 'Table View',
  'pages.talents.view.list': 'List View',
  'pages.talents.column.config': 'Column Config',
  'pages.talents.column.config.desc': 'Customize displayed columns and order',
  'pages.talents.column.reset': 'Reset',
  'pages.talents.column.move.up': 'Move Up',
  'pages.talents.column.move.down': 'Move Down',

  // talents - sort
  'pages.talents.sort.by.recent.contact': 'By Recent Contact',
  'pages.talents.sort.by.created.time': 'By Created Time',
  'pages.talents.keyword.match.all': 'All Keywords',
  'pages.talents.keyword.match.any': 'Any Keyword',

  // talents - work history
  'pages.talents.work.history': 'Work History',
  'pages.talents.work.history.add': 'Add Work History',
  'pages.talents.work.history.company': 'Company Name',
  'pages.talents.work.history.department': 'Department',
  'pages.talents.work.history.position': 'Position',
  'pages.talents.work.history.start.date': 'Start Date',
  'pages.talents.work.history.end.date': 'End Date',
  'pages.talents.work.history.is.current': 'Current Job',
  'pages.talents.work.history.description': 'Job Description',
  'pages.talents.work.history.remove': 'Remove',

  // talents - project experience
  'pages.talents.project.experience': 'Project Experience',
  'pages.talents.project.experience.add': 'Add Project Experience',
  'pages.talents.project.name': 'Project Name',
  'pages.talents.project.role': 'Project Role',
  'pages.talents.project.description': 'Project Description',
  'pages.talents.project.is.current': 'Present',

  // talents - education experience
  'pages.talents.education.experience': 'Education',
  'pages.talents.education.experience.add': 'Add Education',
  'pages.talents.education.school': 'School',
  'pages.talents.education.major': 'Major',
  'pages.talents.education.degree': 'Degree',
  'pages.talents.education.is.fulltime': 'Full-time',
  'pages.talents.education.is.985': '985',
  'pages.talents.education.is.211': '211 / QS200',

  // talents - certificates
  'pages.talents.certificates': 'Certificates',
  'pages.talents.certificates.add': 'Add Certificate',
  'pages.talents.certificate.name': 'Certificate Name',
  'pages.talents.certificate.issuer': 'Issuer',
  'pages.talents.certificate.obtained.at': 'Obtained At',
  'pages.talents.certificate.expired.at': 'Expired At',
  'pages.talents.certificate.grade': 'Grade/Score',

  // talents - expected job
  'pages.talents.expected.job': 'Expected Job',
  'pages.talents.expected.job.add': 'Add Expected Job',
  'pages.talents.expected.position': 'Expected Position',
  'pages.talents.expected.industry': 'Expected Industry',
  'pages.talents.expected.city': 'Expected City',
  'pages.talents.expected.salary.min': 'Expected Min Salary',
  'pages.talents.expected.salary.max': 'Expected Max Salary',

  // talents - skills
  'pages.talents.skills': 'Skills',
  'pages.talents.skills.label': 'Skill Tags',
  'pages.talents.skills.placeholder': 'e.g. Java / React / SQL',

  // talents - avatar
  'pages.talents.avatar.upload': 'Upload Avatar',
  'pages.talents.avatar.uploading': 'Uploading...',

  // talents - search
  'pages.talents.search': 'Search',

  // talents - field min/max
  'pages.talents.field.age.min': 'Min Age',
  'pages.talents.field.age.max': 'Max Age',
  'pages.talents.field.phone.search': 'Phone Search',
  'pages.talents.field.phone.search.placeholder': 'Enter phone to search',
  'pages.talents.field.email.search': 'Email Search',
  'pages.talents.field.email.search.placeholder': 'Enter email to search',
  'pages.talents.field.current.salary.min': 'Min Current Salary',
  'pages.talents.field.current.salary.max': 'Max Current Salary',
  'pages.talents.field.expected.salary.min': 'Min Expected Salary',
  'pages.talents.field.expected.salary.max': 'Max Expected Salary',
  'pages.talents.field.work.experience.min': 'Min Work Experience',
  'pages.talents.field.work.experience.max': 'Max Work Experience',
  'pages.talents.field.source.placeholder': 'Enter source',

  // talents - import
  'pages.talents.import.file.hint': 'Click or drag file to this area to upload',

  // talents - detail
  'pages.talents.detail.title': 'Talent Detail',
  'pages.talents.detail.back': 'Back',
  'pages.talents.detail.basic.info': 'Basic Info',
  'pages.talents.detail.contact.info': 'Contact Info',
  'pages.talents.detail.work.info': 'Work Info',
  'pages.talents.detail.skills.section': 'Skills',
  'pages.talents.detail.tags.section': 'Tags',
  'pages.talents.detail.attachments': 'Resume Attachments',
  'pages.talents.detail.attachments.empty': 'No resume attachments',
  'pages.talents.detail.attachments.load.failed': 'Failed to load attachments',
  'pages.talents.detail.download': 'Download',
  'pages.talents.detail.file.size': 'File Size',
  'pages.talents.detail.file.type': 'File Type',
  'pages.talents.detail.attachments.primary': 'Primary',
  'pages.talents.detail.attachments.uploaded.at': 'Uploaded At',
  'pages.talents.detail.not.found': 'Talent not found',
  'pages.talents.detail.load.failed': 'Failed to load talent detail',
  'pages.talents.detail.current.salary': 'Current Salary',
  'pages.talents.detail.expected.salary': 'Expected Salary',
  'pages.talents.detail.work.experience': 'Work Experience',
  'pages.talents.detail.years.unit': 'years',
  'pages.talents.detail.created.at': 'Created At',
  'pages.talents.detail.updated.at': 'Updated At',
  'pages.talents.detail.position.placeholder': 'No position info',
  'pages.talents.detail.section.empty': 'No data',

  // talents - proficiency
  'pages.talents.proficiency.beginner': 'Beginner',
  'pages.talents.proficiency.intermediate': 'Intermediate',
  'pages.talents.proficiency.advanced': 'Advanced',
  'pages.talents.proficiency.expert': 'Expert',

  // talents - batch operations
  'pages.talents.batch.add.to.private': 'Add to Private Pool ({count})',
  'pages.talents.batch.remove.from.private':
    'Remove from Private Pool ({count})',
  'pages.talents.batch.add.to.collection': 'Add to Collection ({count})',
  'pages.talents.batch.remove.from.collection': 'Remove ({count})',

  // talents - phone
  'pages.talents.phone.view': 'View',
  'pages.talents.phone.hidden': '--',

  // talents - test create page
  'pages.talents.test.create.title': 'Talent Create Test',
  'pages.talents.test.create.subtitle': 'Create talent from resume URL',
  'pages.talents.test.create.description':
    'This page is used to test creating talents from resume URL and phone number.',
  'pages.talents.test.create.api.endpoint': 'API Endpoint',
  'pages.talents.test.create.resume.url': 'Resume URL',
  'pages.talents.test.create.resume.url.required': 'Please enter resume URL',
  'pages.talents.test.create.resume.url.placeholder':
    'e.g. https://example.com/resumes/john_doe_resume.pdf',
  'pages.talents.test.create.phone': 'Phone (optional)',
  'pages.talents.test.create.phone.placeholder': 'e.g. 13800138000',
  'pages.talents.test.create.email': 'Email (optional)',
  'pages.talents.test.create.email.placeholder': 'e.g. john.doe@example.com',
  'pages.talents.test.create.age': 'Age (optional)',
  'pages.talents.test.create.age.placeholder': 'e.g. 28',
  'pages.talents.test.create.file.name': 'File Name',
  'pages.talents.test.create.file.name.placeholder': 'e.g. john_doe_resume.pdf',
  'pages.talents.test.create.file.size': 'File Size (bytes)',
  'pages.talents.test.create.file.size.placeholder': 'e.g. 102400',
  'pages.talents.test.create.file.type': 'File Type (MIME)',
  'pages.talents.test.create.file.type.placeholder': 'e.g. application/pdf',
  'pages.talents.test.create.file.info': 'File Info (optional)',
  'pages.talents.test.create.file.info.desc':
    'These fields are optional. If not provided, they will be extracted from URL or use defaults.',
  'pages.talents.test.create.submit': 'Start Test',
  'pages.talents.test.create.success': 'Create Success',
  'pages.talents.test.create.error': 'Error',
  'pages.talents.test.create.talent.uuid': 'Talent UUID',
  'pages.talents.test.create.talent.name': 'Name',
  'pages.talents.test.create.talent.phone': 'Phone',
  'pages.talents.test.create.talent.email': 'Email',
  'pages.talents.test.create.talent.location': 'Location',
  'pages.talents.test.create.talent.current.company': 'Current Company',
  'pages.talents.test.create.talent.current.position': 'Current Position',
  'pages.talents.test.create.talent.work.experience': 'Work Experience',
  'pages.talents.test.create.talent.status': 'Status',
  'pages.talents.test.create.view.detail': 'View Talent Detail →',

  // talents - additional
  'pages.talents.add': 'Add Talent',
  'pages.talents.detail.load.warning':
    'Partial data loading failed, using cached data',
  'pages.talents.detail.load.permission.error':
    'No permission to view this talent',
  'pages.talents.detail.other.info': 'Other Information',
  'pages.talents.work.history.present': 'Present',
  'pages.talents.field.age.unit': 'years old',
  'pages.talents.field.work.experience.unit': 'years',
  'pages.talents.field.phone.error': 'Please enter a valid phone number',
  'pages.talents.field.phone.exists': 'Phone number {phone} already exists',
  'pages.talents.field.email.error': 'Please enter a valid email',
  'pages.talents.field.status.required': 'Please select status',
  'pages.talents.field.current.salary.tooltip': 'Monthly salary (CNY)',
  'pages.talents.skills.tooltip': 'Press Enter to add skill',
  'pages.talents.work.history.company.required': 'Please enter company name',
  'pages.talents.work.history.position.required': 'Please enter position',
  'pages.talents.education.school.required': 'Please enter school name',
  'pages.talents.project.name.required': 'Please enter project name',
  'pages.talents.certificate.name.required': 'Please enter certificate name',
  'pages.talents.certificate.name.placeholder': 'Please enter certificate name',
  'pages.talents.certificate.issuer.placeholder': 'Please enter issuer',
  'pages.talents.certificate.grade.placeholder': 'Please enter grade or score',

  // talents - import
  'pages.talents.import.upload.success': 'Upload successful',
  'pages.talents.import.file.success': 'Upload successful',
  'pages.talents.import.file.error.format':
    'Only PDF, DOC, DOCX formats are supported',
  'pages.talents.import.file.error.size': 'File size cannot exceed 20MB',
  'pages.talents.import.parsing': 'Parsing...',
  'pages.talents.import.parse.success': 'Resume parsed successfully',
  'pages.talents.import.parse.empty': 'Resume parsing result is empty',
  'pages.talents.import.parse.invalid': 'Resume parsing result is invalid',
  'pages.talents.import.parse.warning': 'Resume parsing failed',

  // talents - avatar
  'pages.talents.avatar.upload.success': 'Avatar uploaded successfully',
  'pages.talents.avatar.upload.failed': 'Avatar upload failed',
  'pages.talents.avatar.upload.error.format':
    'Only JPG, PNG formats are supported',
  'pages.talents.avatar.upload.error.size': 'Image size cannot exceed 2MB',
  'pages.talents.avatar.upload.warning.format':
    'Resume avatar format is incorrect',
  'pages.talents.avatar.upload.warning.size': 'Resume avatar size exceeds 2MB',
  'pages.talents.avatar.upload.from.resume.success':
    'Avatar extracted from resume successfully',
  'pages.talents.avatar.upload.from.resume.failed':
    'Failed to extract avatar from resume',

  // talents - delete confirm additional
  'pages.talents.delete.confirm.content.single':
    'Are you sure you want to delete talent "{name}"? This action cannot be undone.',
  'pages.talents.delete.confirm.content.batch':
    'Are you sure you want to delete {count} selected talents? This action cannot be undone.',
  'pages.talents.delete.select.empty': 'Please select talents to delete',
  'pages.talents.delete.batch.success': 'Successfully deleted {count} talents',
  'pages.talents.delete.batch.failed': 'Batch delete failed',

  // talents - test management
  'pages.talents.test.title': 'Talent Test Management',
  'pages.talents.test.add': 'Add Test',
  'pages.talents.test.edit': 'Edit Test',
  'pages.talents.test.list': 'Test List',
  'pages.talents.test.name': 'Test Name',
  'pages.talents.test.name.required': 'Please enter test name',
  'pages.talents.test.name.placeholder': 'Please enter test name',
  'pages.talents.test.type': 'Test Type',
  'pages.talents.test.type.required': 'Please select test type',
  'pages.talents.test.type.placeholder': 'Please select test type',
  'pages.talents.test.type.technical': 'Technical Test',
  'pages.talents.test.type.personality': 'Personality Test',
  'pages.talents.test.type.language': 'Language Test',
  'pages.talents.test.type.aptitude': 'Aptitude Test',
  'pages.talents.test.type.other': 'Other Test',
  'pages.talents.test.score': 'Score',
  'pages.talents.test.score.required': 'Please enter score',
  'pages.talents.test.score.placeholder': 'Please enter score',
  'pages.talents.test.max.score': 'Max Score',
  'pages.talents.test.max.score.placeholder': 'Please enter max score',
  'pages.talents.test.date': 'Test Date',
  'pages.talents.test.date.required': 'Please select test date',
  'pages.talents.test.valid.until': 'Valid Until',
  'pages.talents.test.description': 'Description',
  'pages.talents.test.description.placeholder': 'Please enter description',
  'pages.talents.test.load.failed': 'Failed to load test list',
  'pages.talents.test.save.failed': 'Failed to save test',
  'pages.talents.test.create.success.msg': 'Test created successfully',
  'pages.talents.test.update.success.msg': 'Test updated successfully',
  'pages.talents.test.delete.success.msg': 'Test deleted successfully',
  'pages.talents.test.delete.failed.msg': 'Failed to delete test',
  'pages.talents.test.error.no.talent': 'Please select a talent first',

  // talent detail
  'pages.talent.detail.notFound': 'Talent not found',
  'pages.talent.detail.loadFailed': 'Failed to load talent details',
  'pages.talent.detail.attachmentsLoadFailed':
    'Failed to load resume attachments',
  'pages.talent.detail.attachmentsEmpty': 'No resume attachments',
  'pages.talent.detail.attachmentsPrimary': 'Primary Resume',
  'pages.talent.detail.attachmentsUploadedAt': 'Upload Time',
  'pages.talent.detail.tabBasicInfo': 'Basic Information',
  'pages.talent.detail.tabAttachments': 'Resume Attachments',
  'pages.talent.detail.basicInfo': 'Basic Information',
  'pages.talent.detail.skillsSection': 'Skills',
  'pages.talent.detail.tagsSection': 'Tags',
  'pages.talent.detail.sectionEmpty': 'No content',
  'pages.talent.detail.currentSalary': 'Current Salary',
  'pages.talent.detail.expectedSalary': 'Expected Salary',
  'pages.talent.detail.workExperience': 'Years of Experience',
  'pages.talent.detail.yearsUnit': 'years',
  'pages.talent.detail.positionPlaceholder': 'Not provided',
  'pages.talent.detail.createdAt': 'Created At',
  'pages.talent.detail.updatedAt': 'Updated At',
  'pages.talent.detail.fileSize': 'File Size',
  'pages.talent.detail.fileType': 'File Type',
  'pages.talent.detail.resumeDownloadFailed': 'Failed to download resume',

  // talent test create
  'pages.talent.testCreate.back': 'Back',
  'pages.talent.testCreate.title': 'Talent Test Creation',
  'pages.talent.testCreate.subtitle': 'Create talent from resume URL',
  'pages.talent.testCreate.description':
    'This page is used to test the API for creating talents and associated data from resume URLs and phone numbers.',
  'pages.talent.testCreate.apiLabel': 'API Address:',
  'pages.talent.testCreate.resumeUrl': 'Resume URL',
  'pages.talent.testCreate.resumeUrlRequired': 'Please enter resume URL',
  'pages.talent.testCreate.resumeUrlInvalid': 'Please enter a valid URL',
  'pages.talent.testCreate.resumeUrlTooltip':
    'Complete URL of the resume file, must be accessible',
  'pages.talent.testCreate.resumeUrlPlaceholder':
    'e.g.: https://example.com/resumes/john_doe_resume.pdf',
  'pages.talent.testCreate.phoneOptional': 'Phone (Optional)',
  'pages.talent.testCreate.phoneInvalid': 'Please enter a valid phone number',
  'pages.talent.testCreate.phoneTooltip':
    'If not provided, the phone number from resume parsing will be used',
  'pages.talent.testCreate.phonePlaceholder': 'e.g.: 13800138000',
  'pages.talent.testCreate.emailOptional': 'Email (Optional)',
  'pages.talent.testCreate.emailInvalid': 'Please enter a valid email address',
  'pages.talent.testCreate.emailTooltip':
    'If not provided, the email from resume parsing will be used',
  'pages.talent.testCreate.emailPlaceholder': 'e.g.: john.doe@example.com',
  'pages.talent.testCreate.ageOptional': 'Age (Optional)',
  'pages.talent.testCreate.ageInvalid': 'Age must be between 18 and 65',
  'pages.talent.testCreate.ageTooltip':
    'If not provided, the age from resume parsing will be used',
  'pages.talent.testCreate.agePlaceholder': 'e.g.: 28',
  'pages.talent.testCreate.fileInfoLabel': 'File Information (Optional)',
  'pages.talent.testCreate.fileInfoDescription':
    'The following fields are optional. If not provided, they will be extracted from the URL or use default values',
  'pages.talent.testCreate.fileName': 'File Name',
  'pages.talent.testCreate.fileNameTooltip':
    'If not provided, the file name will be extracted from the URL',
  'pages.talent.testCreate.fileNamePlaceholder': 'e.g.: john_doe_resume.pdf',
  'pages.talent.testCreate.fileSize': 'File Size (Bytes)',
  'pages.talent.testCreate.fileSizeTooltip': 'File size in bytes',
  'pages.talent.testCreate.fileSizePlaceholder': 'e.g.: 102400',
  'pages.talent.testCreate.fileType': 'File Type (MIME)',
  'pages.talent.testCreate.fileTypeTooltip':
    'If not provided, it will be inferred from the file extension',
  'pages.talent.testCreate.fileTypePlaceholder': 'e.g.: application/pdf',
  'pages.talent.testCreate.submit': 'Start Test',
  'pages.talent.testCreate.cancel': 'Cancel',
  'pages.talent.testCreate.errorTitle': 'Error Message',
  'pages.talent.testCreate.successTitle': 'Created Successfully',
  'pages.talent.testCreate.createSuccess': 'Created successfully!',
  'pages.talent.testCreate.createFailed': 'Creation failed',
  'pages.talent.testCreate.talentUuid': 'Talent UUID',
  'pages.talent.testCreate.city': 'City',
  'pages.talent.testCreate.workYears': 'Years of Experience',
  'pages.talent.testCreate.viewDetail': 'View Talent Details',

  // client create
  'pages.clients.create.addTitle': 'Add Client',
  'pages.clients.create.editTitle': 'Edit Client',
  'pages.clients.create.cancel': 'Back',
  'pages.clients.create.action.save': 'Save',
  'pages.clients.create.create.success': 'Client created successfully',
  'pages.clients.create.update.success': 'Client updated successfully',
  'pages.clients.create.save.failed':
    'Failed to save client, please try again later.',
  'pages.clients.create.field.companyType': 'Company Type',
  'pages.clients.create.field.companyType.placeholder':
    'Please select company type',
  'pages.clients.create.field.name': 'Company Name',
  'pages.clients.create.field.name.required': 'Please enter company name',
  'pages.clients.create.field.name.placeholder': 'Please enter company name',
  'pages.clients.create.field.industry': 'Industry',
  'pages.clients.create.field.industry.required': 'Please select industry',
  'pages.clients.create.field.industry.placeholder': 'Please select industry',
  'pages.clients.create.field.source': 'Client Source',
  'pages.clients.create.field.source.placeholder':
    'Please select client source',
  'pages.clients.create.field.scale': 'Company Scale',
  'pages.clients.create.field.scale.placeholder': 'Please select company scale',
  'pages.clients.create.field.city': 'City',
  'pages.clients.create.field.city.placeholder': 'Please enter city',
  'pages.clients.create.field.level': 'Client Level',
  'pages.clients.create.field.level.placeholder': 'Please select level',
  'pages.clients.create.field.status': 'Status',
  'pages.clients.create.field.status.placeholder': 'Please select status',
  'pages.clients.create.status.active': 'Active',
  'pages.clients.create.status.potential': 'Potential',
  'pages.clients.create.status.lost': 'Lost',
  'pages.clients.create.field.developmentStage': 'Development Stage',
  'pages.clients.create.field.developmentStage.placeholder':
    'Please select development stage',
  'pages.clients.create.field.enterpriseNature': 'Enterprise Nature',
  'pages.clients.create.field.enterpriseNature.placeholder':
    'Please select enterprise nature',
  'pages.clients.create.field.location': 'Location',
  'pages.clients.create.field.location.placeholder': 'Please enter location',
  'pages.clients.create.field.website': 'Company Website',
  'pages.clients.create.field.website.placeholder':
    'Please enter company website URL',
  'pages.clients.create.field.description': 'Company Introduction',
  'pages.clients.create.field.description.placeholder':
    'Describe the business, scale, and highlights. This is shown on hunter task details.',
  'pages.clients.create.field.foundedAt': 'Founded Date',
  'pages.clients.create.field.tags': 'Tags',
  'pages.clients.create.field.tags.placeholder':
    'Enter tags and press Enter to confirm',
  'pages.clients.create.detailInfo': 'Detailed Information',
  'pages.clients.create.field.businessRevenue':
    'Business Revenue (Sales Performance)',
  'pages.clients.create.field.financingStatus':
    'Financing Status / Market Value',
  'pages.clients.create.field.companyOverview':
    'Company Overview (Including Core Technical Staff)',
  'pages.clients.create.field.peopleScaleDescription':
    'People Scale (Number, Education Structure, Personnel Source, etc.)',
  'pages.clients.create.field.orgStructure':
    'Organization Structure and Job Levels',
  'pages.clients.create.field.developmentStrategy':
    'Company Development Strategy',
  'pages.clients.create.field.developmentProspect':
    'Company Development Prospect (Including Core Technical Staff)',
  'pages.clients.create.field.mainProducts':
    'Company Products (Main Business, Product Lines or Industry Ranking, etc.)',
  'pages.clients.create.field.mainCompetitors':
    'Main Competitors (Main Customers)',
  'pages.clients.create.field.competitorAdvantagesAndDisadvantages':
    'Main Competitors Advantages and Disadvantages',
  'pages.clients.create.field.employerBrandHighlights':
    'Company Advantages and Talent Attraction Points',
  'pages.clients.create.field.salaryAndBenefits':
    'Salary and Benefits (Car Allowance, Meal Allowance, Housing Subsidy, etc.)',
  'pages.clients.create.field.commuteAndEnvironment':
    'Commute Experience and Office Environment',
  'pages.clients.create.field.productAndBusinessGoals':
    'Current Products and Business Short-term / Mid-term Strategic Goals',
  'pages.clients.create.contactInfo': 'Contact Information',
  'pages.clients.create.field.contactName': 'Contact Name',
  'pages.clients.create.field.contactName.required':
    'Please enter contact name',
  'pages.clients.create.field.contactName.placeholder':
    'Please enter contact name',
  'pages.clients.create.field.contactPhone': 'Contact Phone',
  'pages.clients.create.field.contactPhone.required':
    'Please enter contact phone',
  'pages.clients.create.field.contactPhone.placeholder':
    'Please enter mobile or landline (e.g.: 010-12345678)',
  'pages.clients.create.field.contactPhone.valid':
    'Please enter a valid mobile or landline number',
  'pages.clients.create.field.contactPosition': 'Position',
  'pages.clients.create.field.contactPosition.placeholder':
    'Please enter position',
  'pages.clients.create.field.contactEmail': 'Email',
  'pages.clients.create.field.contactEmail.placeholder':
    'Please enter email address',
  'pages.clients.create.field.contactEmail.valid':
    'Please enter a valid email address',
  'pages.clients.create.field.contactWechat': 'WeChat',
  'pages.clients.create.field.contactWechat.placeholder':
    'Please enter WeChat ID',

  // client detail
  'pages.clients.detail.action.addContact': 'Add Contact',
  'pages.clients.detail.action.addProject': 'Add Project',
  'pages.clients.detail.action.addJob': 'Add Job',
  'pages.clients.detail.action.addCommunication': 'Add Communication',
  'pages.clients.detail.action.addCompetitiveResearch':
    'Add Competitive Research',
  'pages.clients.detail.action.follow': 'Follow',
  'pages.clients.detail.action.edit': 'Edit',
  'pages.clients.detail.back': 'Back',
  'pages.clients.detail.update.success': 'Updated Successfully',
  'pages.clients.detail.noPermission.edit':
    'You do not have permission to edit',
  'pages.clients.detail.contact.create.success': 'Contact Created Successfully',
  'pages.clients.detail.contact.update.success': 'Contact Updated Successfully',
  'pages.clients.detail.contact.associate.success':
    'Contact Associated Successfully',
  'pages.clients.detail.communication.create.success':
    'Communication Created Successfully',
  'pages.clients.detail.communication.update.success':
    'Communication Updated Successfully',
  'pages.clients.detail.communication.delete.success':
    'Communication Deleted Successfully',
  'pages.clients.detail.billing.create.success': 'Billing Created Successfully',
  'pages.clients.detail.billing.update.success': 'Billing Updated Successfully',
  'pages.clients.detail.billing.delete.success': 'Billing Deleted Successfully',

  // talent collection
  'pages.talents.collection.create.new': 'Create New Collection',
  'pages.talents.reset': 'Reset',

  // analytics
  'pages.analytic.load.error': 'Failed to load analytics data',

  // menu
  'menu.generateRecommendationReport': 'Generate Recommendation Report',

  // common
  'pages.common.notProvided': 'Not provided',

  // ==================== Project Detail Page Additional Translations ====================
  // Action related
  'pages.project.action.deadline': 'Deadline',
  'pages.project.action.owner.placeholder': 'Please select owner',
  'pages.project.action.placeholder': 'Please enter action content',

  // Batch operations
  'pages.project.batch.remove.confirm': 'Confirm Batch Remove',
  'pages.project.batch.remove.content':
    'Are you sure you want to remove the selected candidates from the project?',
  'pages.project.batch.remove.failed': 'Batch Remove Failed',
  'pages.project.batch.remove.success': 'Batch Remove Successful',
  'pages.project.batch.update.title': 'Batch Update Candidates',

  // Background check related
  'pages.project.bgcheck.in.progress': 'In Progress',

  // Delete candidate
  'pages.project.delete.candidate.confirm': 'Confirm Delete',
  'pages.project.delete.candidate.content':
    'Are you sure you want to delete this candidate?',
  'pages.project.delete.candidate.failed': 'Failed to Delete Candidate',
  'pages.project.delete.candidate.success': 'Candidate Deleted Successfully',

  // Project details
  'pages.project.detail.candidate.no.talent':
    'This candidate is not associated with talent information',
  'pages.project.detail.load.history.failed': 'Failed to Load History',
  'pages.project.detail.recommendation.reports': 'Recommendation Reports',

  // Feedback related
  'pages.project.feedback.placeholder': 'Please enter feedback content',

  // Interview related
  'pages.project.interview.first': '1st Round',
  'pages.project.interview.second': '2nd Round',
  'pages.project.interview.third': '3rd Round',
  'pages.project.interview.fourth': '4th Round',
  'pages.project.interview.interviewer': 'Interviewer',
  'pages.project.interview.onsite': 'Onsite Interview',
  'pages.project.interview.phone': 'Phone Interview',
  'pages.project.interview.video': 'Video Interview',

  // Offer related
  'pages.project.offer.allowance': 'Allowance',
  'pages.project.offer.amount': 'Amount',
  'pages.project.offer.base.salary': 'Base Salary',
  'pages.project.offer.bonus': 'Bonus',
  'pages.project.offer.consultant': 'Consultant',
  'pages.project.offer.expected.onboard.date': 'Expected Onboard Date',
  'pages.project.offer.item.type': 'Salary Item Type',
  'pages.project.offer.other': 'Other',
  'pages.project.offer.quantity': 'Quantity',
  'pages.project.offer.salary.items': 'Salary Items',
  'pages.project.offer.stock': 'Stock/Options',

  // Performance allocation
  'pages.project.performance.allocations': 'Performance Allocations',

  // Probation
  'pages.project.probation.in.progress': 'In Probation',

  // Recommendation related
  'pages.project.recommendation.load.failed': 'Failed to Load Recommendations',
  'pages.project.record.feedback': 'Record Feedback',

  // Risk related
  'pages.project.risk.no.update': 'No Update for Long Time',

  // Selection related
  'pages.project.select.candidate': 'Select Candidate',
  'pages.project.select.target.stage': 'Select Target Stage',

  // Business stages

  // Project columns
  'pages.projects.column.performance.allocation': 'Performance Allocation',

  // Project status
  'pages.projects.status.planning': 'In Progress',
  'pages.projects.status.in_progress': 'In Progress',
  'pages.projects.status.on_hold': 'On Hold',
  'pages.projects.status.completed': 'Completed',
  'pages.projects.status.cancelled': 'Cancelled',
  'pages.projects.status.reason': 'Reason',
  'pages.projects.status.reason.required': 'Please enter a reason',
  'pages.projects.status.reason.placeholder.on_hold':
    'Enter the pause reason, e.g. the client postponed hiring',
  'pages.projects.status.reason.placeholder.cancelled':
    'Enter the cancellation reason',
  'pages.projects.status.confirm.on_hold.title': 'Pause project',
  'pages.projects.status.confirm.cancelled.title': 'Cancel project',
  'pages.projects.status.confirm.completed.title': 'Complete project',
  'pages.projects.status.confirm.completed.content':
    'Mark this project as completed?',
  'pages.projects.status.update.success': 'Project status updated',
  'pages.projects.status.update.failed': 'Failed to update project status',

  // AI assistant

  // Matching analysis modal
  'recruitAssistant.matchingAnalysisModal.title': 'AI Job-Candidate Matching',
  'recruitAssistant.matchingAnalysisModal.candidate': 'Candidate',
  'recruitAssistant.matchingAnalysisModal.job': 'Job',
  'recruitAssistant.matchingAnalysisModal.status': 'Status',
  'recruitAssistant.matchingAnalysisModal.statusCompleted': 'Completed',
  'recruitAssistant.matchingAnalysisModal.statusProcessing': 'Processing',
  'recruitAssistant.matchingAnalysisModal.statusPending': 'Pending',
  'recruitAssistant.matchingAnalysisModal.statusFailed': 'Failed',
  'recruitAssistant.matchingAnalysisModal.statusUnknown': 'Unknown',
  'recruitAssistant.matchingAnalysisModal.overallScore': 'Overall Score',
  'recruitAssistant.matchingAnalysisModal.skillMatch': 'Skill Match',
  'recruitAssistant.matchingAnalysisModal.experienceMatch': 'Experience Match',
  'recruitAssistant.matchingAnalysisModal.educationMatch': 'Education Match',
  'recruitAssistant.matchingAnalysisModal.noData': 'No Data',
  'recruitAssistant.matchingAnalysisModal.noResult': 'No Result',
  'recruitAssistant.matchingAnalysisModal.noAnalysisResult':
    'No Analysis Result',
  'recruitAssistant.matchingAnalysisModal.analyzing': 'Analyzing...',
  'recruitAssistant.matchingAnalysisModal.downloadPdf': 'Download PDF',
  'recruitAssistant.matchingAnalysisModal.downloadWord': 'Download Word',
  'recruitAssistant.matchingAnalysisModal.createdAt': 'Created At',
  'recruitAssistant.matchingAnalysisModal.updatedAt': 'Updated At',
  'recruitAssistant.matchingAnalysisModal.executionTime': 'Execution Time',
  'recruitAssistant.matchingAnalysisModal.seconds': 's',
  'recruitAssistant.matchingAnalysisModal.tokenUsage': 'Token Usage',
  'recruitAssistant.matchingAnalysisModal.cost': 'Cost',
  'recruitAssistant.matchingAnalysisModal.llmProvider': 'LLM Provider',
  'recruitAssistant.matchingAnalysisModal.llmModel': 'LLM Model',
  'recruitAssistant.matchingAnalysisModal.errorMessage': 'Error Message',
};
